import { useEffect, useState, useRef } from 'react';
import { SafeAreaView, Alert, StyleSheet, View, Text, ScrollView, Image, TouchableOpacity, Modal, Pressable, TextInput, Animated } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Linking, ActivityIndicator } from 'react-native';
import { differenceInCalendarDays } from 'date-fns';
import { Platform } from 'react-native';  // ✅ Ensure Platform is imported

import { Keyboard, TouchableWithoutFeedback } from 'react-native';

const App = ({ navigation }) => {
  const [userData, setUserData] = useState({});
  const [collabs, setCollabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const [alertCollabs, setAlertCollabs] = useState([]); // Collabs in the alert timeframe
  const [showAlertSymbol, setShowAlertSymbol] = useState(false); // Show alert icon
  const [showCollabModal, setShowCollabModal] = useState(false); // Modal visibility
  const [currentCollab, setCurrentCollab] = useState(null); // Collab in the modal
  
  

  const [suggestedUsers, setSuggestedUsers] = useState([]);
  const [loadingSuggested, setLoadingSuggested] = useState(false);
  

  const [brandListings, setBrandListings] = useState([]);

  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

const [showSegmentModal, setShowSegmentModal] = useState(false);
const [segmentStep, setSegmentStep] = useState(1);
const [segmentQuality, setSegmentQuality] = useState('');
const [segmentRhythm, setSegmentRhythm] = useState('');
const [segmentSaving, setSegmentSaving] = useState(false);
const [segmentError, setSegmentError] = useState('');
  

const [showOfferPromptModal, setShowOfferPromptModal] = useState(false);
const [dismissedOfferPromptModal, setDismissedOfferPromptModal] = useState(false);

const [isSubscriber, setIsSubscriber] = useState(false);


const [planStatusLoaded, setPlanStatusLoaded] = useState(false);

const [showFreemiumPopup, setShowFreemiumPopup] = useState(false);
const [freemiumProofIndex, setFreemiumProofIndex] = useState(0);
const [freemiumCloseReady, setFreemiumCloseReady] = useState(false);

const [suggestedListing, setSuggestedListing] = useState(null);
const [showSuggestedListingModal, setShowSuggestedListingModal] = useState(false);
const [suggestedListingCloseReady, setSuggestedListingCloseReady] = useState(false);



const [showCustomerQueryModal, setShowCustomerQueryModal] = useState(false);
const [showCustomerQueryBubble, setShowCustomerQueryBubble] = useState(true);
const [customerQueryMessage, setCustomerQueryMessage] = useState('');
const [customerQueryPhone, setCustomerQueryPhone] = useState('');
const [customerQuerySubmitting, setCustomerQuerySubmitting] = useState(false);
const [customerQueryError, setCustomerQueryError] = useState('');
const [customerQuerySuccess, setCustomerQuerySuccess] = useState('');
const [customerQueryRef, setCustomerQueryRef] = useState('');

const customerBubbleAutoHideRef = useRef(null);
const customerBubbleScrollEndRef = useRef(null);
const customerBubbleHideDelayRef = useRef(null);

const customerBubbleOpacity = useRef(new Animated.Value(1)).current;
const customerBubbleTranslateX = useRef(new Animated.Value(0)).current;
const customerBubbleScale = useRef(new Animated.Value(1)).current;

const freemiumProofs = [
  "Six By Nico — one visit, 200k+ views",
  "Le Grand Bus, Mayfair — 100+ booking requests",
  "Plied and Prejudice, West End — 1m views",
  'Del74 — "Can’t recommend it enough"',
];

// === EASY LIST ONBOARDING MODAL ===
const [showEasyModal, setShowEasyModal] = useState(false);
const [easyStep, setEasyStep] = useState(0);
const [easyStats, setEasyStats] = useState(null);




const easyListModalShown = useRef(false);


const isEasyListUser =
  userData?.UserSource?.toLowerCase().includes("easy list");



const [brandFollowers, setBrandFollowers] = useState({ human: '—', raw: 0 });
const [bfLoading, setBfLoading] = useState(true);

useEffect(() => {
  if (!userData?.Username) return;
  setBfLoading(true);
  fetch('https://collabbayadmin.com/APIControllers/FetchBrandCombinedFollowerCount.php', {
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => {
      if (data.status === 'success') {
        setBrandFollowers({ human: data.human_readable, raw: data.combined_followers });
      } else {
        setBrandFollowers({ human: '—', raw: 0 });
      }
    })
    .catch(() => setBrandFollowers({ human: '—', raw: 0 }))
    .finally(() => setBfLoading(false));
}, [userData?.Username]);




// mini audience bubble
const [showAudienceBubble, setShowAudienceBubble] = useState(false);
const [audienceCount, setAudienceCount] = useState(0);
const bubbleTimerRef = useRef(null);


const [showUpcomingTip, setShowUpcomingTip] = useState(false);

// Booking feed scroll hint
const [showBookingFeedTip, setShowBookingFeedTip] = useState(true);
const bookingFeedArrowY = useRef(new Animated.Value(0)).current;

useEffect(() => {
  const bounce = Animated.loop(
    Animated.sequence([
      Animated.timing(bookingFeedArrowY, {
        toValue: 5,
        duration: 450,
        useNativeDriver: true,
      }),
      Animated.timing(bookingFeedArrowY, {
        toValue: 0,
        duration: 450,
        useNativeDriver: true,
      }),
    ])
  );

  bounce.start();

  const hideTip = () => setShowBookingFeedTip(false);

  if (typeof window !== 'undefined') {
    if (window.scrollY > 5) {
      setShowBookingFeedTip(false);
    }

    window.addEventListener('scroll', hideTip, { passive: true });
  }

  return () => {
    bounce.stop();

    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', hideTip);
    }
  };
}, []);

// compact number (1.2K / 3.4M / 1B)
const formatHuman = (n) => {
  if (n >= 1e9) return (n/1e9).toFixed(n>=1e10?0:1).replace(/\.0$/,'') + 'B';
  if (n >= 1e6) return (n/1e6).toFixed(n>=1e7?0:1).replace(/\.0$/,'') + 'M';
  if (n >= 1e3) return (n/1e3).toFixed(n>=1e4?0:1).replace(/\.0$/,'') + 'K';
  return String(Math.round(n));
};

// show bubble on ~40% of loads once followers known
useEffect(() => {
  if (!userData?.Username) return;
  if (brandFollowers.raw > 0 && Math.random() < 0.4) setShowAudienceBubble(true);
}, [userData?.Username, brandFollowers.raw]);

// tick number up to target
useEffect(() => {
  if (!showAudienceBubble) return;
  const target = Math.max(0, Number(brandFollowers.raw) || 0);
  const duration = 1200;           // ms
  const steps = 30;                // frames
  const stepTime = Math.max(16, Math.floor(duration / steps));
  let cur = 0;
  const inc = target / steps;

  setAudienceCount(0);
  bubbleTimerRef.current = setInterval(() => {
    cur += inc;
    if (cur >= target) {
      cur = target;
      clearInterval(bubbleTimerRef.current);
    }
    setAudienceCount(Math.round(cur));
  }, stepTime);

  return () => clearInterval(bubbleTimerRef.current);
}, [showAudienceBubble, brandFollowers.raw]);



useEffect(() => {
  if (
    userData.Username &&
    brandListings.length === 0 &&
    !showTutorial &&
    !errorMessage &&
    !dismissedOfferPromptModal
  ) {
    setShowOfferPromptModal(true);
  }
}, [userData, brandListings, showTutorial, errorMessage]);

  
useEffect(() => {
  if (userData?.Username) {
    fetchBrandListings();
  }
}, [userData]);

useEffect(() => {
  if (!userData.Username) {
    setShowLoginPrompt(true);
  }
}, [userData]);


useEffect(() => {
  if (!userData?.Username) return;

  fetch('https://collabbayadmin.com/APIControllers/CheckSuggestedListingsForBrand.php', {
    credentials: 'include',
  })
    .then(res => res.json())
    .then(data => {
      if (!data?.success || !data?.hasSuggestedListing) return;

      setSuggestedListing(data.listing || null);

      const sessionKey = `collabbay_suggested_listing_modal_seen_${userData.Username}`;
      const alreadyShown = sessionStorage.getItem(sessionKey) === 'Y';

      if (!alreadyShown) {
        sessionStorage.setItem(sessionKey, 'Y');

        setTimeout(() => {
          setShowSuggestedListingModal(true);

          setTimeout(() => {
            setSuggestedListingCloseReady(true);
          }, 3000);
        }, 3000);
      }
    })
    .catch(() => {});
}, [userData?.Username]);

useEffect(() => {
  if (!userData?.Username) return;

  fetch('https://collabbayadmin.com/APIControllers/CheckIfSegmented.php', {
    credentials: 'include',
  })
    .then(res => res.json())
    .then(data => {
      if (data?.success && data?.requiresSegmentation) {
        setShowSegmentModal(true);
      }
    })
    .catch(() => {});
}, [userData?.Username]);

  const fetchBrandListings = async () => {
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/RetrieveBrandListings.php');
      const json = await response.json();
  
      // Filter listings belonging to the logged-in user
      const filtered = Array.isArray(json)
        ? json.filter(item => item.BrandName === userData.Username)
        : [];
  
      setBrandListings(filtered);
    } catch (error) {
      console.error('Error fetching brand listings:', error);
      setBrandListings([]); // fail silently with empty
    }
  };
  

  const [recentOnline, setRecentOnline] = useState([]);
  const [recentCount, setRecentCount] = useState(0);
  
  const fetchRecentlyOnline = async () => {
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/RecentlyOnlineCreators.php');
      const data = await response.json();
  
      if (data.status === 'success') {
        setRecentOnline(data.users || []);
        setRecentCount(data.count || 0);
      }
    } catch (error) {
      console.error('Error fetching recent online users:', error);
    }
  };
  
  useEffect(() => {
    fetchRecentlyOnline();
  }, []);
  


  useEffect(() => {
    if (userData.Username) {  // ✅ Only fetch if user is logged in
      fetchSuggestedUsers();
    }
  }, [userData]);  // Runs after userData loads

  const fetchSuggestedUsers = async () => {
    setLoadingSuggested(true);
  
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/GetSuggestedUsersForBrand.php', {
        credentials: 'include',  // ✅ Send session cookie
      });
  
      const data = await response.json();
  
      if (data.status === 'success') {
        setSuggestedUsers(data.users);
      } else {
        setSuggestedUsers([]);
      }
  
    } catch (error) {
      console.error('Error fetching suggested users:', error);
      setSuggestedUsers([]);
    }
  
    setLoadingSuggested(false);
  };
  

  const [totalCollabCount, setTotalCollabCount] = useState(0);

const fetchTotalCollabCount = () => {
  fetch('https://collabbayadmin.com/APIControllers/GetCollabCount.php', {
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 'success') {
        setTotalCollabCount(data.count);
      }
    })
    .catch((error) => {
      console.error('Error fetching collab count:', error);
    });
};

// Call it after userData loads
useEffect(() => {
  if (userData.Username) {
    fetchTotalCollabCount();
  }
}, [userData]);

  

// === FETCH PSYCHE STATS AND TRIGGER POPUP ===
useEffect(() => {
  if (!userData?.Username) return;

  fetch("https://collabbayadmin.com/APIControllers/CheckUserPsyche.php", {
    credentials: "include",
  })
    .then(res => res.json())
    .then(data => {
      // If user has accepted 2 or more → show popup
      if (data.accepted >= 2) {
        setShowPsychePopup(true);
      }
    })
    .catch(err => console.error("Psyche error:", err));
}, [userData]);



  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [venueCode, setVenueCode] = useState('');

  // === PSYCHE POPUP ===
const [showPsychePopup, setShowPsychePopup] = useState(false);


  const tutorialSteps = [
    {
      icon: null,
      message: (
        <span>
          <strong>You're in ✨.</strong>Welcome to the network.
        </span>
      ),
    },
    {
      icon: 'add',
      message: (
        <span>
          Before you start taking creator bookings,<strong> here's a quick intro</strong>.
        </span>
      ),
    },
    {
      icon: 'laptop',
      message: (
        <span>
          Firstly, this is your venue's control centre. All influencer booking requests, due content, and upcoming collabs are tracked here. 
        </span>
      ),
    },
    {
      icon: 'calendar',
      message: (
        <span>
          You simply list a comped offer, receive collab requests, and only accept the creators you like. <strong>The platform handles the rest</strong>.
        </span>
      ),
    },
    {
      icon: null,
      message: 'All influencer visits are securely tracked and logged on collabbay. Choose how influencers will redeem your offers when they visit:',
      options: [
        {
          header: 'Give a passcode (suggested)',
          subheader: (
            <span>
              Give the influencer a <strong>2-digit code</strong> 
            </span>
          ),
          value: 'VenueCode',
          icon: 'key-outline',
        },
        {
          header: 'Scan a QR',
          subheader: (
            <span>
              Scan the influencer's <strong>QR code</strong> 
            </span>
          ),
          value: 'QR',
          icon: 'qr-code-outline',
        },
        {
          header: '',
          subheader: 'Not sure yet',
          value: 'both',
          icon: null,
          small: true,
        },
      ],
    },
    {
      icon: null,
      message: (
        <span>
          Now it's time to get <strong>your brand in front of the right creators.</strong> 
        </span>
      ),
    },
  ];
  


  const [selectedOption, setSelectedOption] = useState(''); // Track selected option
  const [isUpdating, setIsUpdating] = useState(false); // Track API call status
  
  const handleOptionSelect = (value) => {
    setSelectedOption(value);
  
    // Call the API to update the database
    fetch('https://collabbayadmin.com/APIControllers/SelectVenueRedeemChoice.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        UserID: userData.UserID, // Ensure UserID is available
        Choice: value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.Status === 'Success') {
          console.log('VenueRedeemSystem updated successfully');
        } else {
          console.error('Error updating VenueRedeemSystem:', data.Message);
        }
      })
      .catch((error) => console.error('API Error:', error));
  };
  

  useEffect(() => {
    fetchUserData();
    fetchCollabData();
  }, []);


useEffect(() => {
  if (!userData?.UserSource) return;

  const isEasy = userData.UserSource.toLowerCase().includes("easy list");

  // ✅ Only if Easy List
  // ✅ Only if LoginCount < 3
  // ✅ Only one time per session
  if (isEasy && Number(userData?.LoginCount) < 3 && !easyListModalShown.current) {
    easyListModalShown.current = true; 
    setShowEasyModal(true);
    setEasyStep(0);
  }
}, [userData]);


const renderEasyListModal = () => {
  if (!showEasyModal) return null;

  const closeModal = () => {
    setShowEasyModal(false);
    setEasyStep(0);
  };

  const next = () => {
    if (easyStep < 4) {
      setEasyStep(easyStep + 1);
    } else {
      closeModal();
    }
  };

  return (
    <Modal visible={true} transparent animationType="fade">
      <View style={{
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.8)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20
      }}>
        
        {/* X BUTTON */}
        <TouchableOpacity
          onPress={closeModal}
          style={{
            position: 'absolute',
            top: 50,
            right: 30,
            zIndex: 50,
            padding: 10
          }}
        >
          <Ionicons name="close" size={28} color="white" />
        </TouchableOpacity>

        {/* CARD */}
        <View style={{
          width: '100%',
          maxWidth: 450,
          borderRadius: 20,
          backgroundColor: '#000',
          padding: 20,
          alignItems: 'center',
          overflow: 'hidden'
        }}>

          {/* SLIDE 0 — Welcome video */}
          {easyStep === 0 && (
            <View style={{ width: '100%', alignItems: 'center' }}>

              {Platform.OS === 'web' && (
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    width: '100%',
                    height: 330,
                    borderRadius: 12,
                    marginBottom: 20,
                    objectFit: 'cover'
                  }}
                >
                  <source
                    src="https://collabbayadmin.com/BlackWhiteContentShowcase.mp4"
                    type="video/mp4"
                  />
                </video>
              )}

              <Text style={{
                fontSize: 26,
                fontWeight: 'bold',
                color: 'white',
                textAlign: 'center'
              }}>
                You're in ✨
              </Text>

              <Text style={{
                color: 'white',
                opacity: 0.8,
                marginTop: 10,
                textAlign: 'center'
              }}>
                Welcome to Collabbay — let's show you around.
              </Text>
            </View>
          )}

          {/* SLIDE 1 — Business Overview */}
          {easyStep === 1 && (
            <View style={{ width: '100%' }}>
              <Text
                style={{ color: 'white', fontSize: 22, fontWeight: 'bold', marginBottom: 10 }}
              >
                How Collabbay works
              </Text>

              <Text style={{ color: 'white', opacity: 0.75, marginBottom: 20 }}>
                On Collabbay, creators apply to visit your venue in exchange for a gifted offer.
              </Text>

              <Text style={{ color: 'white', marginBottom: 8 }}>• Your comped offer is shown in our marketplace</Text>
              <Text style={{ color: 'white', marginBottom: 8 }}>• Creators apply — you get email notifications</Text>
              <Text style={{ color: 'white', marginBottom: 8 }}>• Accept the ones you like. Ignore the rest.</Text>

              <Text style={{ color: 'white', marginTop: 20, fontWeight: 'bold' }}>
                No more messy DMs, email chains or no-shows.
              </Text>
            </View>
          )}

          {/* SLIDE 2 — REAL LIVE STATS */}
      {easyStep === 2 && (
  <View style={{ width: '100%', alignItems: 'center' }}>

    {/* ========== CARD 1 — ACTIVE CREATORS (LIVE) ========== */}
    <View style={{
      width: '92%',
      backgroundColor: '#fff',
      borderRadius: 20,
      paddingVertical: 20,
      paddingHorizontal: 20,
      marginTop: 10,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.10,
      shadowRadius: 6,
      elevation: 2,
      borderWidth: 1,
      borderColor: '#efefef',
    }}>

      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 16, fontWeight: '400', color: '#222' }}>
          Active Creators
        </Text>

        <View style={{
          backgroundColor: '#eaffea',
          paddingVertical: 4,
          paddingHorizontal: 10,
          borderRadius: 12,
          borderWidth: 1,
          borderColor: '#4CD964'
        }}>
          <Text style={{ color: '#2ac45e', fontSize: 12, fontWeight: '600' }}>
            LIVE
          </Text>
        </View>
      </View>

      <Text style={{ marginTop: 20, fontSize: 42, fontWeight: '800', color: '#000' }}>
        500+
      </Text>

      <Text style={{ fontSize: 14, color: '#666', marginTop: 2 }}>
        vetted creators
      </Text>
    </View>



    {/* ========== CARD 2 — COMBINED REACH ========== */}
    <View style={{
      width: '92%',
      backgroundColor: '#fff',
      borderRadius: 20,
      paddingVertical: 20,
      paddingHorizontal: 20,
      marginTop: 14,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.10,
      shadowRadius: 6,
      elevation: 2,
      borderWidth: 1,
      borderColor: '#efefef',
    }}>
      <Text style={{ fontSize: 16, fontWeight: '400', color: '#222' }}>
        Combined Reach
      </Text>

      <Text style={{ marginTop: 20, fontSize: 42, fontWeight: '800', color: '#000' }}>
        {easyStats ? easyStats.combinedReach.toLocaleString() : '…'}
      </Text>

      <Text style={{ fontSize: 14, color: '#666', marginTop: 2 }}>
        followers across the network
      </Text>
    </View>



    {/* ========== CARD 3 — BOOKINGS REQUESTED ========== */}
    <View style={{
      width: '92%',
      backgroundColor: '#fff',
      borderRadius: 20,
      paddingVertical: 20,
      paddingHorizontal: 20,
      marginTop: 14,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.10,
      shadowRadius: 6,
      elevation: 2,
      borderWidth: 1,
      borderColor: '#efefef',
    }}>
      <Text style={{ fontSize: 16, fontWeight: '400', color: '#222' }}>
        Bookings Requested
      </Text>

      <Text style={{ marginTop: 20, fontSize: 42, fontWeight: '800', color: '#000' }}>
        {easyStats ? easyStats.totalBookings : '…'}
      </Text>

      <Text style={{ fontSize: 14, color: '#666', marginTop: 2 }}>
        all-time on Collabbay
      </Text>
    </View>



    {/* ========== CARD 4 — WEEKLY BOOKINGS ========== */}
    <View style={{
      width: '92%',
      backgroundColor: '#fff',
      borderRadius: 20,
      paddingVertical: 20,
      paddingHorizontal: 20,
      marginTop: 14,
      marginBottom: 20,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.10,
      shadowRadius: 6,
      elevation: 2,
      borderWidth: 1,
      borderColor: '#efefef',
    }}>
      <Text style={{ fontSize: 16, fontWeight: '400', color: '#222' }}>
        Requests This Week
      </Text>

      <Text style={{ marginTop: 20, fontSize: 42, fontWeight: '800', color: '#000' }}>
        {easyStats ? easyStats.weeklyBookings : '…'}
      </Text>

      <Text style={{ fontSize: 14, color: '#666', marginTop: 2 }}>
        already this week
      </Text>
    </View>

  </View>
)}


          {/* SLIDE 3 — Brand Logos + 1M case study */}
          {easyStep === 3 && (
            <View style={{ width: '100%', alignItems: 'center' }}>
              <Text style={{ color: 'white', fontSize: 22, fontWeight: 'bold', marginBottom: 20 }}>
                You’re in good company
              </Text>



<Text style={{ color: 'white', opacity: 0.7, marginBottom: 20 }}>
  Trusted by top London venues and independents.
</Text>

<View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginBottom: 20 }}>
  <Image source={{ uri: 'https://collabbayadmin.com/Timberland.jpg' }} style={{ width: 70, height: 70, borderRadius: 10, margin: 6 }} />
  <Image source={{ uri: 'https://collabbayadmin.com/BlackSheep.jpg' }} style={{ width: 70, height: 70, borderRadius: 10, margin: 6 }} />
  <Image source={{ uri: 'https://collabbayadmin.com/SixByNico.jpg' }} style={{ width: 70, height: 70, borderRadius: 10, margin: 6 }} />
  <Image source={{ uri: 'https://collabbayadmin.com/BreadnAndTruffle.jpg' }} style={{ width: 70, height: 70, borderRadius: 10, margin: 6 }} />

  <View style={{
    width: 70,
    height: 70,
    borderRadius: 10,
    margin: 6,
    backgroundColor: '#1a1a1a',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#333'
  }}>
    <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 22 }}>+70</Text>
  </View>
</View>


              <TouchableOpacity
                onPress={() => Linking.openURL('https://collabbayadmin.com/About.pdf')}
              >
                <Text style={{ color: '#FDF05D', fontWeight: 'bold' }}>
                  See how one collab generated 1M+ views →
                </Text>
              </TouchableOpacity>
            </View>
          )}

          {/* SLIDE 4 — What next? */}
          {easyStep === 4 && (
            <View style={{ width: '100%', alignItems: 'center' }}>
              <Text style={{
                color: 'white', fontSize: 22, fontWeight: 'bold', marginBottom: 10
              }}>
                What next?
              </Text>

              <Text style={{ color: 'white', opacity: 0.8, marginBottom: 20, textAlign: 'center' }}>
                Sit back and wait for bookings to come in — or speed things up by inviting some creators via your browse tool.
              </Text>

  
            </View>
          )}

          {/* NEXT BUTTON */}
          <TouchableOpacity
            onPress={next}
            style={{
              marginTop: 20,
              backgroundColor: '#FDF05D',
              paddingVertical: 10,
              paddingHorizontal: 30,
              borderRadius: 10
            }}
          >
            <Text style={{ fontWeight: 'bold', color: 'black' }}>
              {easyStep === 4 ? 'Finish' : 'Next'}
            </Text>
          </TouchableOpacity>

        </View>
      </View>
    </Modal>
  );
};


useEffect(() => {
  if (easyStep !== 2) return;

  fetch('https://collabbayadmin.com/APIControllers/GetRecentActivity.php')
    .then(res => res.json())
    .then(data => setEasyStats(data))
    .catch(() => setEasyStats(null));
}, [easyStep]);


// Hide / Not Interested state
const [hidingCollabID, setHidingCollabID] = useState(null);

// Legacy menu state still referenced by surrounding card logic
const [showMenuIndex, setShowMenuIndex] = useState(null);





// Handle "Not interested"
const handleNotInterested = (collabID) => {
  if (hidingCollabID) return;

  const hideRequest = async () => {
    try {
      setHidingCollabID(collabID);

      const response = await fetch(
        'https://collabbayadmin.com/APIControllers/BrandHideInfluencerRequest.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ CollabID: collabID }),
        }
      );

      const data = await response.json();

      if (data.Status === 'Success') {
        // Remove immediately from the feed
        setCollabs(prev =>
          prev.filter(collab => collab.CollabID !== collabID)
        );
      } else {
        if (Platform.OS === 'web') {
          window.alert(
            data.Message || 'Couldn’t hide request. Please try again.'
          );
        } else {
          Alert.alert(
            'Couldn’t hide request',
            data.Message || 'Please try again.'
          );
        }
      }
    } catch (error) {
      console.error('Hide request error:', error);

      if (Platform.OS === 'web') {
        window.alert(
          'Couldn’t hide request. Please check your connection and try again.'
        );
      } else {
        Alert.alert(
          'Couldn’t hide request',
          'Please check your connection and try again.'
        );
      }
    } finally {
      setHidingCollabID(null);
      setShowMenuIndex(null);
    }
  };

  // WEB
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const confirmed = window.confirm(
      "Not interested?\n\nWe'll remove this request from your feed."
    );

    if (confirmed) {
      hideRequest();
    }

    return;
  }

  // IOS / ANDROID
  Alert.alert(
    'Not interested?',
    "We'll remove this request from your feed and let the creator know the collab is unlikely to go ahead.",
    [
      {
        text: 'Keep request',
        style: 'cancel',
      },
      {
        text: 'Hide request',
        style: 'destructive',
        onPress: hideRequest,
      },
    ]
  );
};


  const fetchUserData = () => {
    fetch('https://collabbayadmin.com/APIControllers/GetSessionData.php')
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
        if (data.HasSeenTutorial === 0) {
          setShowTutorial(true);
        }
        if (data.VenueCode) {
          setVenueCode(data.VenueCode); // Update venueCode state
        }
      })
      .catch((error) => {
        console.error('Error fetching user data: ', error);
      });
  };


  const renderVenueCodeCard = () => {
    if (!venueCode) {
      console.warn('VenueCode is not available or empty.');
      return null;
    }
  
    return (
      <TouchableOpacity
        onPress={() => Linking.openURL('https://collabbayadmin.com/Visits')}
        style={[styles.venueCodeCard, { marginLeft: 25 }]} // Added marginRight directly
      >
        <Text style={styles.venueCodeText}>
          Your venue code is <Text style={styles.boldText}>{venueCode}</Text>
        </Text>
        <Ionicons name="help-circle-outline" size={20} color="black" style={styles.icon} />
    
        
      </TouchableOpacity>
    );
  };
  
  
  


  const fetchCurrentCollabData = async () => {
    try {
      const response = await fetch('https://collabbayadmin.com/APIControllers/GetCollabCalendarCurrent.php');
      const data = await response.json();
  
      const now = new Date();
      const oneHourBefore = new Date(now.getTime() - 60 * 60 * 1000);
      const fiveHoursAfter = new Date(now.getTime() + 5 * 60 * 60 * 1000);
  
      // Filter collabs that are "Accepted" and fall within the timeframe
      const filteredCollabs = data.filter((collab) => {
        const collabTime = new Date(collab.CreditAvailableStart);
        return (
          collab.Status === 'Accepted' &&
          collabTime >= oneHourBefore &&
          collabTime <= fiveHoursAfter
        );
      });
  
      setAlertCollabs(filteredCollabs); // Update state with filtered collabs
      setShowAlertSymbol(filteredCollabs.length > 0); // Show alert if there are valid collabs
    } catch (error) {
      console.error('Error fetching current collab data:', error);
    }
  };
  
  
  useEffect(() => {
  const unsubscribe = navigation.addListener('focus', () => {
    fetchCollabData();
  });

  return unsubscribe;
}, [navigation]);



  useEffect(() => {
    fetchUserData(); // Fetch user data
    fetchCollabData(); // Fetch general collab data
    fetchCurrentCollabData(); // Fetch current collabs
  }, []);

  const handleAlertPress = () => {
    if (alertCollabs.length > 0) {
      setCurrentCollab(alertCollabs[0]); // Set the first collab
      setShowCollabModal(true); // Open the modal
    }
  };
  

  const handleCollabNavigate = () => {
    setShowCollabModal(false); // Close the modal
    navigation.navigate('SingleCollabMetrics', {
      CollabID: currentCollab.CollabID,
    });
  };


  const getStatusStyle = (status) => {
    switch (status) {
      case 'Expired':
        return { backgroundColor: 'grey', padding: 4, borderRadius: 10 };
      case 'Redeemed':
        return { backgroundColor: 'darkgreen', padding: 4, borderRadius: 10 };
      case 'Upcoming':
        return { backgroundColor: 'lightgreen', padding: 4, borderRadius: 10 };
      case 'Pending':
        return { backgroundColor: 'yellow', padding: 4, borderRadius: 10 };
      case 'Cancelled':
        return { backgroundColor: 'red', padding: 4, borderRadius: 10 };
      case 'Invited':
        return { backgroundColor: '#fdf05d', padding: 4, borderRadius: 10 }; // ✅ NEW CASE
      default:
        return { backgroundColor: 'transparent', padding: 4, borderRadius: 10 };
    }
  };
  
  
  const getStatusIcon = (status) => {
    switch (status) {
      case 'Expired':
        return <Ionicons name="time" size={12} color="black" />;
      case 'Redeemed':
        return <Ionicons name="checkmark-circle" size={12} color="black" />;
      case 'Upcoming':
        return <Ionicons name="calendar" size={12} color="black" />;
      case 'Pending':
        return <Ionicons name="alert-circle" size={12} color="black" />;
      case 'Cancelled':
        return <Ionicons name="close-circle" size={12} color="blackwhite" />;
      default:
        return null;
    }
  };
  
  

  const getCollabStatus = (collab) => {
    if (collab.Status === 'Invited') return 'Invited'; // ✅ Add this
    if (collab.Status === 'Cancelled') return 'Cancelled';
  
    const today = new Date();
    const creditAvailableDate = new Date(collab.CreditAvailableStart);
  
    if (creditAvailableDate < today) {
      if (collab.Redeemed) {
        return 'Redeemed';
      } else {
        return 'Expired';
      }
    } else {
      if (collab.Status === 'Accepted') {
        return 'Upcoming';
      } else if (collab.Status === 'Pending') {
        return 'Pending';
      }
    }
  
    return null;
  };
  
  

const checkUserAuthentication = async () => {
  try {
    const response = await fetch('https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Ensure session cookie is sent
    });
    const data = await response.json();

    setIsAuthenticated(data.authenticated === true);

    setIsSubscriber(data?.auth_mode === 'subscriber');

    setPlanStatusLoaded(true);

    if (!data.authenticated) {
      setErrorMessage('Subscribe to access collabbay features');
    } else {
      setErrorMessage('');
    }
  } catch (error) {
    console.error('Error checking authentication:', error);
    setErrorMessage('An error occurred while checking authentication.');
  }
};


useEffect(() => {
  checkUserAuthentication();
}, []); 







useEffect(() => {
  if (!userData?.Username) return;

  let cancelled = false;

  fetch('https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => {
      if (cancelled) return;

      // Never show to authenticated/full-access users
      if (data?.authenticated === true) return;

      const loginKey =
        `collabbay_login_count_${userData.Username}`;

      const currentCount =
        Number(localStorage.getItem(loginKey) || 0) + 1;

      localStorage.setItem(loginKey, String(currentCount));

      const sessionKey =
        `collabbay_freemium_seen_${userData.Username}`;

      const alreadyShownThisSession =
        sessionStorage.getItem(sessionKey) === 'Y';

      const shouldShow =
        !alreadyShownThisSession &&
        Number(userData?.LoginCount || 0) > 5 &&
        currentCount >= 3 &&
        Math.random() < 0.3;

      if (shouldShow) {
        sessionStorage.setItem(sessionKey, 'Y');

        setShowFreemiumPopup(true);

        setTimeout(() => {
          setFreemiumCloseReady(true);
        }, 3000);
      }
    })
    .catch(() => {
      // Do not show the modal if the subscription check fails
    });

  return () => {
    cancelled = true;
  };
}, [userData?.Username]);




useEffect(() => {
  if (!showFreemiumPopup) return;

  const id = setInterval(() => {
    setFreemiumProofIndex((prev) =>
      (prev + 1) % freemiumProofs.length
    );
  }, 2500);

  return () => clearInterval(id);
}, [showFreemiumPopup]);

   // Function to handle the link press
   const handleSubscribe = () => {
    Linking.openURL('https://collabbayadmin.com/plans');
};










const clearCustomerBubbleTimers = () => {
  if (customerBubbleAutoHideRef.current) {
    clearTimeout(customerBubbleAutoHideRef.current);
    customerBubbleAutoHideRef.current = null;
  }

  if (customerBubbleScrollEndRef.current) {
    clearTimeout(customerBubbleScrollEndRef.current);
    customerBubbleScrollEndRef.current = null;
  }

  if (customerBubbleHideDelayRef.current) {
    clearTimeout(customerBubbleHideDelayRef.current);
    customerBubbleHideDelayRef.current = null;
  }
};

const showCustomerBubbleSmoothly = () => {
  if (showCustomerQueryModal) return;

  setShowCustomerQueryBubble(true);

  Animated.parallel([
    Animated.timing(customerBubbleOpacity, {
      toValue: 1,
      duration: 220,
      useNativeDriver: true,
    }),
    Animated.timing(customerBubbleTranslateX, {
      toValue: 0,
      duration: 220,
      useNativeDriver: true,
    }),
    Animated.timing(customerBubbleScale, {
      toValue: 1,
      duration: 220,
      useNativeDriver: true,
    }),
  ]).start();
};

const hideCustomerBubbleSmoothly = (delay = 0) => {
  if (showCustomerQueryModal) return;

  if (customerBubbleHideDelayRef.current) {
    clearTimeout(customerBubbleHideDelayRef.current);
    customerBubbleHideDelayRef.current = null;
  }

  customerBubbleHideDelayRef.current = setTimeout(() => {
    customerBubbleHideDelayRef.current = null;

    Animated.parallel([
Animated.timing(customerBubbleOpacity, {
  toValue: 0,
  duration: 150,
  useNativeDriver: true,
}),
Animated.timing(customerBubbleTranslateX, {
  toValue: -18,
  duration: 150,
  useNativeDriver: true,
}),
Animated.timing(customerBubbleScale, {
  toValue: 0.92,
  duration: 150,
  useNativeDriver: true,
}),
    ]).start(() => {
      setShowCustomerQueryBubble(false);
    });
  }, delay);
};

const openCustomerQueryModal = () => {
  clearCustomerBubbleTimers();
  setCustomerQueryError('');
  setCustomerQuerySuccess('');
  setCustomerQueryRef('');
  setShowCustomerQueryBubble(false);
  customerBubbleOpacity.setValue(0);
  setShowCustomerQueryModal(true);
};

const closeCustomerQueryModal = () => {
  setShowCustomerQueryModal(false);

  setTimeout(() => {
    showCustomerBubbleSmoothly();
  }, 180);
};

const isValidCustomerPhone = (phone) => {
  const value = String(phone || '').trim();
  if (!value) return true;

  const compact = value.replace(/[()\s.-]/g, '');
  return /^\+?[0-9]{7,15}$/.test(compact);
};

const submitCustomerQuery = () => {
  const message = customerQueryMessage.trim();
  const phone = customerQueryPhone.trim();

  setCustomerQueryError('');
  setCustomerQuerySuccess('');
  setCustomerQueryRef('');

  if (!message) {
    setCustomerQueryError('Please enter a message before sending.');
    return;
  }

  if (!isValidCustomerPhone(phone)) {
    setCustomerQueryError('Please enter a valid phone number, or leave it blank.');
    return;
  }

  if (customerQuerySubmitting) return;

  setCustomerQuerySubmitting(true);

  fetch('https://collabbayadmin.com/APIControllers/LiveBrandCustomerQuery.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      message,
      phone,
    }),
  })
    .then(res => res.json())
    .then(data => {
      if (data?.success) {
        setCustomerQuerySuccess(
          "We'll be in touch as soon as possible- thanks for getting in touch"
        );
        setCustomerQueryRef(data.referenceId || '');
        setCustomerQueryMessage('');
        setCustomerQueryPhone('');
      } else {
        setCustomerQueryError(data?.message || 'Could not send your message. Please try again.');
      }
    })
    .catch(() => {
      setCustomerQueryError('Could not send your message. Please try again.');
    })
    .finally(() => {
      setCustomerQuerySubmitting(false);
    });
};

useEffect(() => {
  if (showCustomerQueryModal || !showCustomerQueryBubble) return;

  if (customerBubbleAutoHideRef.current) {
    clearTimeout(customerBubbleAutoHideRef.current);
  }

  customerBubbleAutoHideRef.current = setTimeout(() => {
    hideCustomerBubbleSmoothly(0);
  }, 15000);

  return () => {
    if (customerBubbleAutoHideRef.current) {
      clearTimeout(customerBubbleAutoHideRef.current);
      customerBubbleAutoHideRef.current = null;
    }
  };
}, [showCustomerQueryBubble, showCustomerQueryModal]);

useEffect(() => {
  if (typeof window === 'undefined') return;

  const handleWindowScroll = () => {
    if (showCustomerQueryModal) return;

    if (customerBubbleAutoHideRef.current) {
      clearTimeout(customerBubbleAutoHideRef.current);
      customerBubbleAutoHideRef.current = null;
    }

    if (!customerBubbleHideDelayRef.current) {
      hideCustomerBubbleSmoothly(500);
    }

    if (customerBubbleScrollEndRef.current) {
      clearTimeout(customerBubbleScrollEndRef.current);
      customerBubbleScrollEndRef.current = null;
    }

    customerBubbleScrollEndRef.current = setTimeout(() => {
      showCustomerBubbleSmoothly();
    }, 1100);
  };

  window.addEventListener('scroll', handleWindowScroll, { passive: true });

  return () => {
    window.removeEventListener('scroll', handleWindowScroll);
    clearCustomerBubbleTimers();
  };
}, [showCustomerQueryModal]);

useEffect(() => {
  return () => {
    clearCustomerBubbleTimers();
  };
}, []);

const submitBrandSegment = () => {
  if (!segmentQuality || !segmentRhythm || segmentSaving) return;

  setSegmentSaving(true);
  setSegmentError('');

  fetch('https://collabbayadmin.com/APIControllers/UpdateBrandSegment.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      qualityInput: segmentQuality,
      rhythmInput: segmentRhythm,
    }),
  })
    .then(res => res.json())
    .then(data => {
      if (data?.success) {
        setShowSegmentModal(false);
        setSegmentStep(1);
        setSegmentQuality('');
        setSegmentRhythm('');
      } else {
        setSegmentError(data?.message || 'Could not save your preferences.');
      }
    })
    .catch(() => setSegmentError('Could not save your preferences.'))
    .finally(() => setSegmentSaving(false));
};



const fetchCollabData = () => {
  fetch('https://collabbayadmin.com/APIControllers/GetCollabCalendar.php', {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(data => {
      // Filter collabs where BrandNotInterested is 'N'
      const filteredData = data.filter(collab => collab.BrandNotInterested !== 'Y');
      setCollabs(filteredData);
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      setLoading(false);
    });
};


// === MISSED REQUESTS ===
const [missedCollabs, setMissedCollabs] = useState([]);
const [loadingMissed, setLoadingMissed] = useState(true);
const [missedFollowerSum, setMissedFollowerSum] = useState(0);

// Convert 5k / 1m → number
const parseFollowers = (v) => {
  if (!v) return 0;
  const s = v.toString().toLowerCase();
  if (s.includes('m')) return parseFloat(s) * 1_000_000;
  if (s.includes('k')) return parseFloat(s) * 1_000;
  return parseInt(s.replace(/\D/g, ''), 10) || 0;
};

// Format number back (e.g. 12.4K)
const formatHumanFollowers = (num) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
};

// "4 PM (3 days ago)"
const formatRelativeDate = (dateString) => {
  const d = new Date(dateString);
  const now = new Date();
  const diffDays = Math.round((d - now) / (1000 * 60 * 60 * 24));
  const hours = d.getHours() % 12 || 12;
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
  if (diffDays === 0) return `${hours}${ampm} (today)`;
  if (diffDays > 0) return `${hours}${ampm} (in ${diffDays} day${diffDays > 1 ? 's' : ''})`;
  return `${hours}${ampm} (${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? 's' : ''} ago)`;
};


// ✅ Get follower range (for non-auth users)
const getFollowerRange = (num) => {
  if (num < 2000) return 'Under 2K';
  if (num < 5000) return '2K–5K Followers';
  if (num < 10000) return '5K–10K Followers';
  if (num < 20000) return '10K–20K Followers';
  if (num < 50000) return '20K–50K Followers';
  if (num < 100000) return '50K–100K Followers';
  if (num < 200000) return '100K–200K Followers';
  if (num < 500000) return '200K–500K Followers';
  if (num < 1000000) return '500K–1M Followers';
  return '1M+';
};


const fetchMissedCollabs = async () => {
  setLoadingMissed(true);
  try {
    const res = await fetch('https://collabbayadmin.com/APIControllers/GetMissedBookings.php', {
      credentials: 'include',
    });
    const data = await res.json();

    if (data.status === 'success') {
      const collabs = data.collabs || [];

      // ✅ Calculate total followers
      const total = collabs.reduce((sum, c) => sum + parseFollowers(c.PlatformFollowers), 0);

      setMissedFollowerSum(total);
      setMissedCollabs(collabs);
    } else {
      setMissedCollabs([]);
      setMissedFollowerSum(0);
    }
  } catch (e) {
    console.error('Missed collabs fetch error:', e);
  } finally {
    setLoadingMissed(false);
  }
};

// Run once userData loaded
useEffect(() => {
  if (userData?.Username) fetchMissedCollabs();
}, [userData]);


  const handleRedoTutorial = () => {
    fetch('https://collabbayadmin.com/APIControllers/RedoTutorial.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.Status === 'Success') {
          console.log('Tutorial reset successfully.');
          // Show the tutorial again and reset to the first step
          setShowTutorial(true);
          setCurrentStep(0);
          // Reload the page or refresh the data
          navigation.reset({
            index: 0,
            routes: [{ name: 'BusinessHomepage' }], // or your main screen name
          });
        } else {
          console.error('Error resetting tutorial status: ', data.Message);
        }
      })
      .catch(error => {
        console.error('Error resetting tutorial status: ', error);
      });
  };
  
  

  const renderTutorialButton = () => (
    <TouchableOpacity style={styles.redoButton} onPress={handleRedoTutorial}>
      <Ionicons name="book" size={20} color="black" />
    </TouchableOpacity>
  );
  
  
  const handleNextStep = () => {
    if (currentStep === 0 && selectedOption) {
      // Update database if it's the options step
      setIsUpdating(true); // Start updating
      fetch('https://collabbayadmin.com/APIControllers/SelectVenueRedeemChoice.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          Choice: selectedOption, // Send the selected option
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setIsUpdating(false); // Stop updating
          if (data.Status === 'Success') {
            console.log('VenueRedeemSystem updated successfully');
          } else {
            console.error('Error updating VenueRedeemSystem:', data.Message);
          }
          moveToNextStep(); // Move to the next step after updating
        })
        .catch((error) => {
          setIsUpdating(false); // Stop updating
          console.error('API Error:', error);
          moveToNextStep(); // Move to the next step even if there's an error
        });
    } else {
      moveToNextStep(); // Just move to the next step if no API call is needed
    }
  };
  

  const moveToNextStep = () => {
  if (currentStep < tutorialSteps.length - 1) {
    setCurrentStep(prev => prev + 1);
    return;
  }

  // We're on the last step -> mark as seen and close the tutorial
  updateHasSeenTutorial();
  setShowTutorial(false);

  // If the user isn't subscribed/authenticated, send them to GuidedOfferSetup
  if (!isAuthenticated) {
    navigation.navigate('GuidedOfferSetup');
  }
};

  
  

  const updateHasSeenTutorial = () => {
    fetch('https://collabbayadmin.com/APIControllers/UpdateHasSeenTutorial.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        UserID: userData.UserID,
        HasSeenTutorial: 1,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.Status !== 'Success') {
          console.error('Error updating tutorial status: ', data.Message);
        }
      })
      .catch(error => {
        console.error('Error updating tutorial status: ', error);
      });
  };


  const renderTutorial = () => {
    if (!showTutorial || currentStep >= tutorialSteps.length) {
      return null;
    }
  
    const step = tutorialSteps[currentStep];
  
    return (
      <Modal transparent visible={showTutorial} animationType="slide">
        <View style={styles.modalOverlay}>
          <View style={styles.tutorialCard}>
            <Text style={styles.tutorialText}>{step.message}</Text>
  
            {step.options && (
              <View>
                {step.options.map((option, index) => (
                  <TouchableOpacity
                    key={index}
                    style={[
                      styles.optionButton,
                      selectedOption === option.value && styles.optionButtonSelected,
                      option.small && styles.optionButtonSmall,
                    ]}
                    onPress={() => handleOptionSelect(option.value)}
                  >
                    {option.icon && (
                      <Ionicons
                        name={option.icon}
                        size={24}
                        color="black"
                        style={styles.optionIcon}
                      />
                    )}
                    <View>
                      <Text style={styles.optionHeader}>{option.header}</Text>
                      {option.subheader && (
                        <Text style={styles.optionSubheader}>
                          {option.subheader}
                        </Text>
                      )}
                    </View>
                  </TouchableOpacity>
                ))}
              </View>
            )}
  
            <Pressable
              style={[styles.nextButton, !selectedOption && { opacity: 0.5 }]}
              onPress={handleNextStep}
              disabled={isUpdating || (step.options && !selectedOption)} // Disable if updating or no option selected
            >
              <Text style={styles.buttonText}>
                {isUpdating ? 'Updating...' : currentStep < tutorialSteps.length - 1 ? 'Next' : 'Continue'}
              </Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    );
  };
  

  const handleQRCodeScan = () => {
    Linking.openURL('https://collabbayadmin.com/QR.html');
  };



const handleCardPress = (collabID, index, promoter) => {
  const isTrialRow = index === 0; // only the first row is free

  if (!isAuthenticated && !isTrialRow) {
    // 🔁 Redirect to CreatorPreview for locked creators
    navigation.navigate('CreatorPreview', {
      CollabID: collabID,
      Promoter: promoter,
    });
    return;
  }

  // ✅ Normal flow for free/unlocked creators
  navigation.navigate('SingleCollabMetrics', { CollabID: collabID });
};

  

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  
    const formattedDate = `${day}${getOrdinalSuffix(day)} ${month} ${hours}:${minutes}${ampm}`;
  
    // Calculate days difference
    const today = new Date();
    const diffDays = differenceInCalendarDays(date, today);
  
    const dayCountText =
      diffDays === 0
        ? 'today'
        : diffDays > 0
        ? `in ${diffDays} day${diffDays > 1 ? 's' : ''}`
        : `${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? 's' : ''} ago`;
  
    return `${formattedDate} (${dayCountText})`;
  };
  

const getDaysUntil = (dateString) => {
  const target = new Date(dateString);
  const today = new Date();
  const diff = differenceInCalendarDays(target, today);
  return Math.max(0, diff); // never negative
};






  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  

  if (loading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
        <ActivityIndicator size="large" color="black" />
      </View>
    );
  }

const visibleCollabs = Array.isArray(collabs)
  ? collabs.filter(c => c.BrandNotInterested !== 'Y')
  : [];

// Safe timestamp helpers
const ts = (v, fallback = Number.POSITIVE_INFINITY) => {
  const t = v ? Date.parse(v) : NaN;
  return Number.isNaN(t) ? fallback : t;
};
const creditTS = (c) => ts(c?.CreditAvailableStart);            // for main ordering
const plainDateTS = (c) => ts(c?.Date, Number.POSITIVE_INFINITY); // for picking the free row

// 1) Base list for display: CreditAvailableStart ascending (soonest → latest)
const byCreditAsc = [...visibleCollabs].sort((a, b) => {
  const aUnseen =
    String(a?.HasBrandSeenOffer || '').trim().toUpperCase() !== 'Y';

  const bUnseen =
    String(b?.HasBrandSeenOffer || '').trim().toUpperCase() !== 'Y';

  // Unseen first
  if (aUnseen !== bUnseen) {
    return aUnseen ? -1 : 1;
  }

  // Same existing date order within each group
  return creditTS(a) - creditTS(b);
});

// 2) If authenticated → done
let displayCollabs = byCreditAsc;

// 3) If NOT authenticated → pick the single free row by oldest `Date`,
//    put it at the top, then show the rest by CreditAvailableStart ascending.
if (!isAuthenticated && byCreditAsc.length > 0) {
  // Filter out cancelled first
  const eligible = [...visibleCollabs].filter(c => getCollabStatus(c) !== 'Cancelled');

  // Oldest by `Date` among non-cancelled (fallback handled by plainDateTS)
  const trialTop = eligible.sort((a, b) => plainDateTS(a) - plainDateTS(b))[0];

  if (trialTop) {
    const restAsc = byCreditAsc.filter(c => c.CollabID !== trialTop.CollabID);
    displayCollabs = [trialTop, ...restAsc];
  } else {
    // If everything is cancelled (or no eligible), keep existing order (nothing unlocked)
    displayCollabs = byCreditAsc;
  }
}

  return (
    
    <TouchableWithoutFeedback onPress={() => setShowMenuIndex(null)}>
    <View style={{ flex: 1, width: '100%', backgroundColor: '#fff' }}>

<SafeAreaView style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>

{Platform.OS === 'web' && userData.Username && showBookingFeedTip && (
<TouchableOpacity
  activeOpacity={0.9}
  onPress={() => {
    document
      .getElementById('my-requests-section')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    setShowBookingFeedTip(false);
  }}
  style={{
      position: 'fixed',
      bottom: 22,
      left: 0,
      right: 0,
      alignItems: 'center',
      zIndex: 999998,
    }}
  >
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#2563eb',
        paddingVertical: 9,
        paddingHorizontal: 15,
        borderRadius: 999,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.18,
        shadowRadius: 10,
      }}
    >
      <Text
        style={{
          color: 'white',
          fontSize: 15,
          fontWeight: '700',
          marginRight: 7,
        }}
      >
        Scroll down for your booking feed
      </Text>

      <Animated.View
        style={{
          transform: [{ translateY: bookingFeedArrowY }],
        }}
      >
        <Ionicons name="arrow-down" size={17} color="white" />
      </Animated.View>
    </View>
</TouchableOpacity>
)}
{!showCustomerQueryModal && (
  <Animated.View
    pointerEvents={showCustomerQueryBubble ? 'auto' : 'none'}
    style={[
      styles.customerChatFloatWrap,
      {
        opacity: customerBubbleOpacity,
        transform: [
          { translateX: customerBubbleTranslateX },
          { scale: customerBubbleScale },
        ],
      },
    ]}
  >
    <TouchableOpacity
      activeOpacity={0.88}
      style={styles.customerChatFloat}
      onPress={openCustomerQueryModal}
      accessibilityRole="button"
      accessibilityLabel="Contact Collabbay support"
    >
      <Ionicons name="chatbubble-ellipses" size={25} color="#FDF05D" />
      <View style={styles.customerChatFloatPulse} />
    </TouchableOpacity>
  </Animated.View>
)}


<Modal
  visible={showCustomerQueryModal}
  transparent
  animationType="fade"
  onRequestClose={closeCustomerQueryModal}
>
  <TouchableWithoutFeedback
    onPress={() => {
      Keyboard.dismiss();
      closeCustomerQueryModal();
    }}
  >
    <View style={styles.customerSupportOverlay}>
      <TouchableWithoutFeedback onPress={() => {}}>
        <View style={styles.customerSupportModal}>
        <TouchableOpacity
          style={styles.customerSupportClose}
          onPress={closeCustomerQueryModal}
          activeOpacity={0.8}
        >
          <Text style={styles.customerSupportCloseText}>×</Text>
        </TouchableOpacity>

        <View style={styles.customerSupportTop}>
          <View style={styles.customerSupportIcon}>
<Ionicons name="chatbubble-ellipses" size={22} color="#FDF05D" />
          </View>

          <View style={{ flex: 1 }}>
            <Text style={styles.customerSupportTitle}>
              How can we help? Don't hesitate to get in touch.
            </Text>

            <Text style={styles.customerSupportSub}>
              Send the Collabbay team a quick message. This is not a live chat, but it goes straight to our team.
            </Text>
          </View>
        </View>

        {customerQuerySuccess ? (
          <View style={styles.customerSupportSuccess}>
            <Text style={styles.customerSupportSuccessText}>
              {customerQuerySuccess}
            </Text>

            {!!customerQueryRef && (
              <View style={styles.customerSupportRef}>
                <Text style={styles.customerSupportRefText}>
                  Reference: {customerQueryRef}
                </Text>
              </View>
            )}

            <View style={styles.customerSupportFaqRow}>
              <Text style={styles.customerSupportFaqText}>
                If your query is usage related,{' '}
              </Text>

              <TouchableOpacity
                onPress={() => Linking.openURL('https://collabbayadmin.com/FAQs')}
              >
                <Text style={styles.customerSupportFaqLink}>
                  here's a quick tutorial
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        ) : (
          <View style={styles.customerSupportForm}>
            <View style={styles.customerSupportField}>
              <Text style={styles.customerSupportLabel}>Message</Text>

              <TextInput
                style={styles.customerSupportTextarea}
                value={customerQueryMessage}
                onChangeText={setCustomerQueryMessage}
                placeholder="Tell us what you need help with..."
                placeholderTextColor="#9CA3AF"
                multiline
                maxLength={1500}
                textAlignVertical="top"
              />
            </View>

            <View style={styles.customerSupportField}>
              <View style={styles.customerSupportLabelRow}>
                <Text style={styles.customerSupportLabel}>Mobile number</Text>
                <Text style={styles.customerSupportRecommended}>Recommended</Text>
              </View>

              <TextInput
                style={styles.customerSupportInput}
                value={customerQueryPhone}
                onChangeText={setCustomerQueryPhone}
                placeholder="e.g. 07123 456789"
                placeholderTextColor="#9CA3AF"
                keyboardType="phone-pad"
                maxLength={25}
              />
            </View>

            {!!customerQueryError && (
              <View style={styles.customerSupportError}>
                <Text style={styles.customerSupportErrorText}>
                  {customerQueryError}
                </Text>
              </View>
            )}

            <TouchableOpacity
              style={[
                styles.customerSupportSubmit,
                customerQuerySubmitting && styles.customerSupportSubmitDisabled,
              ]}
              onPress={submitCustomerQuery}
              disabled={customerQuerySubmitting}
              activeOpacity={0.85}
            >
              <Text style={styles.customerSupportSubmitText}>
                {customerQuerySubmitting ? 'Sending...' : 'Send message'}
              </Text>
            </TouchableOpacity>
          </View>
        )}
                </View>
      </TouchableWithoutFeedback>
    </View>
  </TouchableWithoutFeedback>
</Modal>


  <Modal visible={showSuggestedListingModal && !!suggestedListing} transparent animationType="fade">
  <View style={styles.suggestedListingOverlay}>
    <View style={styles.suggestedListingModal}>
      <TouchableOpacity
        style={[
          styles.suggestedListingClose,
          !suggestedListingCloseReady && styles.suggestedListingCloseLocked,
        ]}
        onPress={() => {
          if (!suggestedListingCloseReady) return;
          setShowSuggestedListingModal(false);
        }}
      >
        <Text style={styles.suggestedListingCloseText}>×</Text>
      </TouchableOpacity>

      <View style={styles.suggestedListingIcon}>
        <Text style={styles.suggestedListingIconText}>✨</Text>
      </View>

      <Text style={styles.suggestedListingModalTitle}>
        Our team has hand-prepared something for you...
      </Text>

      <Text style={styles.suggestedListingModalSub}>
        We’ve prepped an offer you can edit and post as needed. It’s based on your account details and what tends to perform well on collabbay™.
      </Text>

      <View style={styles.suggestedListingMiniOffer}>
        <Text style={styles.suggestedListingMiniLabel}>Suggested offer</Text>
        <Text style={styles.suggestedListingMiniText}>
          {suggestedListing?.NonCreditOffer || 'Prepared offer'}
        </Text>

        {suggestedListing?.Credits ? (
          <Text style={styles.suggestedListingMiniValue}>
            Rough value: £{suggestedListing.Credits}
          </Text>
        ) : null}
      </View>

      <TouchableOpacity
        style={styles.suggestedListingPrimaryBtn}
       onPress={() => {
  setShowSuggestedListingModal(false);

  Linking.openURL(
    `https://collabbayadmin.com/Introduction.html?Brand=${encodeURIComponent(userData.Username)}`
  );
}}
      >
        <Text style={styles.suggestedListingPrimaryText}>
          View my suggested offer
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.suggestedListingGhostBtn}
        onPress={() => setShowSuggestedListingModal(false)}
      >
        <Text style={styles.suggestedListingGhostText}>Not now</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>

<Modal visible={showFreemiumPopup} transparent animationType="fade">
  <View style={styles.freemiumOverlay}>
    <View style={styles.freemiumModal}>

      <TouchableOpacity
        style={[
          styles.freemiumClose,
          !freemiumCloseReady && styles.freemiumCloseLocked,
        ]}
        onPress={() => {
          if (!freemiumCloseReady) return;
          setShowFreemiumPopup(false);
        }}
      >
        <Text style={styles.freemiumCloseText}>×</Text>
      </TouchableOpacity>

      <Text style={styles.freemiumTitle}>
        Want to fill {userData?.BrandName || userData?.Username || 'your venue'} with{' '}
        <Text style={styles.freemiumTitleBold}>customers</Text>, our premium creators and none of the faff?
      </Text>

      <TouchableOpacity
        style={styles.freemiumTryBtn}
        onPress={handleSubscribe}
      >
        <View style={styles.freemiumBtnInner}>
          <View style={styles.freemiumBtnTick}>
            <Text style={styles.freemiumBtnTickText}>✓</Text>
          </View>

          <Text style={styles.freemiumBtnText}>
            Try boosted footfall with full access
          </Text>
        </View>
      </TouchableOpacity>

      <View style={styles.freemiumProof}>
        <View style={styles.verifyTick}>
          <Text style={styles.verifyTickText}>✓</Text>
        </View>

        <Text style={styles.freemiumProofText}>
          {freemiumProofs[freemiumProofIndex]}
        </Text>
      </View>

    </View>
  </View>
</Modal>

<Modal visible={showSegmentModal} transparent animationType="fade">
  <View style={styles.segmentOverlay}>
    <View style={styles.segmentCard}>
      <Text style={styles.segmentKicker}>Customisation</Text>

  <Text style={styles.segmentTitle}>
  <Text
    style={{
      color: 'black'}}
  >
    Tailor
  </Text>{' '}
  your collabs
</Text>

      <View style={styles.segmentDots}>
        {[1, 2, 3].map(n => (
          <View key={n} style={[styles.segmentDot, segmentStep === n && styles.segmentDotActive]} />
        ))}
      </View>

      {segmentStep === 1 && (
        <>
          <Text style={styles.segmentQuestion}>How would someone describe your venue?</Text>

          {[
            { label: 'Michelin-starred', badge: '★ £££' },
            { label: 'Refined Elegance', badge: '£££' },
            { label: 'Local Gem', badge: '££' },
            { label: 'Casual and Quick', badge: '£' },
          ].map(item => {
            const selected = segmentQuality === item.label;
            return (
              <TouchableOpacity key={item.label} onPress={() => setSegmentQuality(item.label)} style={[styles.segmentOption, selected && styles.segmentOptionSelected]}>
                <Text style={styles.segmentOptionText}>{item.label}</Text>
                <View style={styles.segmentRight}>
                  <Text style={styles.segmentBadge}>{item.badge}</Text>
                  <View style={[styles.segmentRadio, selected && styles.segmentRadioSelected]} />
                </View>
              </TouchableOpacity>
            );
          })}

          <TouchableOpacity disabled={!segmentQuality} onPress={() => setSegmentStep(2)} style={[styles.segmentNextBtn, !segmentQuality && { opacity: 0.45 }]}>
            <Text style={styles.segmentNextText}>Next</Text>
          </TouchableOpacity>
        </>
      )}

      {segmentStep === 2 && (
        <>
          <Text style={styles.segmentQuestion}>What rhythm of influencer collab-requests suit your business?</Text>

          {[
            { label: 'Any interest that we can get', badge: '▲▲▲' },
            { label: 'A steady flow to choose from', badge: '▲▲' },
            { label: 'Occasional, select collabs', badge: '▲' },
          ].map(item => {
            const selected = segmentRhythm === item.label;
            return (
              <TouchableOpacity key={item.label} onPress={() => setSegmentRhythm(item.label)} style={[styles.segmentOption, selected && styles.segmentOptionSelected]}>
                <Text style={styles.segmentOptionText}>{item.label}</Text>
                <View style={styles.segmentRight}>
                  <Text style={styles.segmentBadge}>{item.badge}</Text>
                  <View style={[styles.segmentRadio, selected && styles.segmentRadioSelected]} />
                </View>
              </TouchableOpacity>
            );
          })}

          <View style={styles.segmentButtonRow}>
            <TouchableOpacity onPress={() => setSegmentStep(1)} style={styles.segmentBackBtn}>
              <Text style={styles.segmentBackText}>Back</Text>
            </TouchableOpacity>

            <TouchableOpacity disabled={!segmentRhythm} onPress={() => setSegmentStep(3)} style={[styles.segmentNextBtn, { flex: 1 }, !segmentRhythm && { opacity: 0.45 }]}>
              <Text style={styles.segmentNextText}>Next</Text>
            </TouchableOpacity>
          </View>
        </>
      )}

      {segmentStep === 3 && (
        <>
          <Text style={styles.segmentQuestion}>Confirm your preferences</Text>

          <View style={styles.segmentSummary}>
            <Text style={styles.segmentSummaryText}>Venue style: {segmentQuality}</Text>
            <Text style={styles.segmentSummaryText}>Collab rhythm: {segmentRhythm}</Text>
          </View>

          {!!segmentError && <Text style={styles.segmentError}>{segmentError}</Text>}

          <View style={styles.segmentButtonRow}>
            <TouchableOpacity onPress={() => setSegmentStep(2)} style={styles.segmentBackBtn}>
              <Text style={styles.segmentBackText}>Back</Text>
            </TouchableOpacity>

            <TouchableOpacity disabled={segmentSaving} onPress={submitBrandSegment} style={[styles.segmentNextBtn, { flex: 1 }]}>
              <Text style={styles.segmentNextText}>{segmentSaving ? 'Saving…' : 'Confirm'}</Text>
            </TouchableOpacity>
          </View>
        </>
      )}
    </View>
  </View>
</Modal>

<View style={styles.container}>

{userData.Username ? (
  isAuthenticated ? (
    null // Show nothing if authenticated
  ) : (
    errorMessage && (
      !showTutorial ? (
null

      ) : (
        <TouchableOpacity onPress={handleSubscribe} style={styles.messageContainer}>
          <Text style={styles.messageText}>{errorMessage}</Text>
          <Ionicons name="arrow-forward" size={50} color="black" />
        </TouchableOpacity>
      )
    )
  )
) : null}



        </View>

  {renderTutorialButton()}
  
      <View contentContainerStyle={styles.contentContainer}>
        <View>


<View style={styles.header}>
  <View style={styles.headerRow}>
    <Image
      style={styles.smallRoundedLogo}
      source={{ uri: 'https://collabbayadmin.com/CollabbayLogoDark.png' }}
    />

    <View style={styles.mobileHeaderIdentity}>
      <View style={styles.mobileHeaderTitleRow}>
        <Text style={styles.mobileHeaderGreeting}>
          Hi 👋, {userData.Username ? ` ${userData.Username}` : 'log in to collab'}
        </Text>

        {userData.Username && planStatusLoaded && (
          <TouchableOpacity
            style={styles.mobileAccountPlanBadge}
            activeOpacity={0.82}
            onPress={() =>
              Linking.openURL('https://collabbayadmin.com/plans')
            }
          >

            <Text
              style={styles.mobileAccountPlanName}
              numberOfLines={1}
            >
              {isSubscriber
                ? 'Standard Plan • Pro Access'
                : 'Free Access Plan'}
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  </View>
</View>

{/* === ROW: Switch pill (left, only if logged in) + Recently Online (right, unchanged) === */}
<View style={styles.ctaRowWrap}>
  {/* Switch pill — only show if logged in */}
  {userData.Username && (
    <View style={styles.ctaPillAnchor}>
      <TouchableOpacity
        style={styles.ctaPill}
     onPress={() => navigation.navigate('MyPanel')}
        accessibilityRole="button"
        accessibilityLabel="Switch to desktop"
      >
        {/* Background glow/gradient layers (visual only) */}
        <View style={styles.ctaPillBg} />
        <View style={styles.ctaPillGlow} />
        <View style={styles.ctaBlobA} />
        <View style={styles.ctaBlobB} />
        <View style={styles.ctaSparkA} />
        <View style={styles.ctaSparkB} />

        {/* Foreground content */}
        <View style={styles.ctaContent}>
          <Ionicons name="laptop-outline" size={16} color="#000" style={{ marginRight: 8 }} />
          <Text style={styles.ctaText} numberOfLines={1}>Switch to desktop ✨</Text>
          <Ionicons name="chevron-forward" size={16} color="#000" style={styles.ctaChevron} />
        </View>
      </TouchableOpacity>

      {/* NEW badge overlapping top-right of pill */}
      <View style={styles.ctaNewBadge} pointerEvents="none">
        <Text style={styles.ctaNewBadgeText}>NEW</Text>
      </View>
    </View>
  )}

  {/* === Recently Online (UNCHANGED STYLES / ALWAYS SHOWS) === */}
  <View style={styles.recentlyOnlineCard}>
    <Text style={styles.recentlyOnlineLabel}>Recently Online</Text>
    <View style={styles.avatarRow}>
      {recentOnline.slice(0, 3).map((user, index) => (
        <View
          key={index}
          style={[
            styles.avatarWrapper,
            { marginLeft: index === 0 ? 0 : -10, zIndex: 3 - index },
          ]}
        >
          <Image source={{ uri: user.ProfileImage }} style={styles.avatarImage} />
          {index === 0 && <View style={styles.greenDot} />} {/* ✅ Only on first */}
        </View>
      ))}

      {recentCount > 3 && (
        <Text style={styles.plusCountText}>+{recentCount - 3}</Text>
      )}
    </View>
  </View>
</View>


<View style={styles.scrollableContainer}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.cardScrollContainer}
      >
        <View style={styles.videoCard}>
          <video autoPlay loop muted playsInline style={styles.videoBackground}>
            <source src="https://collabbayadmin.com/Admin%20Web%20Intro%20%20Collabbay%20App%20(1).mp4" type="video/mp4" />
          </video>
        </View>

  
        {!userData.Username ? (
  // ✅ Show time if user is NOT logged in
  <TouchableOpacity
    style={styles.videoCard}
    onPress={() => console.log('No user logged in')}
  >
    <View style={styles.venueCodeCardContent}>
    <Text style={[styles.venueCodeValue, { fontSize: 35 }]}>
        {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </Text>
    </View>

  </TouchableOpacity>
) : (
  // ✅ Show venue code card if user is logged in
  <TouchableOpacity
    style={styles.videoCard}
    onPress={() => Linking.openURL('https://collabbayadmin.com/Visits')}
  >
    <View style={styles.venueCodeCardContent}>
      <Text style={styles.venueCodeLabel}>Your venue code is</Text>
      <Text style={styles.venueCodeValue}>
        {venueCode ? venueCode : '--'}
      </Text>
    </View>

    <Ionicons
      name="help-circle-outline"
      size={24}
      color="#fff"
      style={styles.iconBottomCard}
    />
  </TouchableOpacity>
)}




        <View style={styles.videoCard}>
          <video autoPlay loop muted playsInline style={styles.videoBackground}>
            <source src="https://collabbay.com/Influencer%20App%20Video%20-%20II.mp4" type="video/mp4" />
          </video>
        </View>

        <View style={styles.videoCard}>
          <Text style={styles.cardTitle}>
            Go #viral<Text style={{ fontWeight: 'bold', color: '#FDF05D' }}>.</Text>
          </Text>
          <Text style={styles.cardSubTitle}>
  
          </Text>
        </View>
      </ScrollView>
    </View>
 


 {userData.Username && suggestedListing && (
  <TouchableOpacity
    style={styles.suggestedListingInfoCard}
  onPress={() =>
  Linking.openURL(
    `https://collabbayadmin.com/Introduction.html?Brand=${encodeURIComponent(userData.Username)}`
  )
}
  >
    <View style={styles.suggestedListingInfoIcon}>
      <Text style={styles.suggestedListingInfoIconText}>i</Text>
    </View>

    <View style={styles.suggestedListingInfoTextWrap}>
      <Text style={styles.suggestedListingInfoTitle}>
        We’ve prepared a suggested offer for you
      </Text>

      <Text style={styles.suggestedListingInfoSub}>
        Our team has drafted an offer you can edit and post in a few clicks.
        {suggestedListing?.NonCreditOffer ? ` Suggested: ${suggestedListing.NonCreditOffer}` : ''}
      </Text>
    </View>

    <Ionicons name="chevron-forward" size={18} color="#12334f" />
  </TouchableOpacity>
)}

{userData.Username && brandListings.length === 0 && (
  <View
    style={{
      backgroundColor: '#fdf05d',
      borderRadius: 15,
      padding: 20,
      marginVertical: 20,
      alignItems: 'center',
      justifyContent: 'center',
      width: '90%',
      alignSelf: 'center',
      position: 'relative',
    }}
  >
    {/* Notification Bell in top-right */}
    <TouchableOpacity
      onPress={() => navigation.navigate('NotificationsPage')}
      style={{
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 10,
      }}
    >
      <Ionicons name="notifications-outline" size={22} color="black" />
      <View
        style={{
          position: 'absolute',
          top: 1,
          right: 1,
          width: 8,
          height: 8,
          borderRadius: 4,
          backgroundColor: 'green',
        }}
      />
    </TouchableOpacity>

    {/* Main CTA */}
    <TouchableOpacity
      onPress={() => navigation.navigate('GuidedOfferSetup')}
      style={{ alignItems: 'center' }}
    >
      <Ionicons name="add-circle-outline" size={28} color="black" style={{ marginBottom: 8 }} />
      <Text style={{ color: 'black', fontWeight: 'bold', fontSize: 20, marginBottom: 4, textAlign: 'center'}}>
        Post an offer to start taking influencer bookings
      </Text>
      <Text style={{ color: 'black', fontSize: 14 }}>
        You're one step away.
      </Text>
    </TouchableOpacity>
  </View>
)}


{/* === Positive Reviews CTA === */}
{!loading && userData?.Username && (
  <TouchableOpacity
    style={styles.positiveReviewsBar}
    onPress={() => {
      if (!isAuthenticated) {
        Linking.openURL('https://collabbayadmin.com/plans');
      } else {
        navigation.navigate('MyReviews');
      }
    }}
    activeOpacity={0.88}
  >
    <View style={styles.positiveReviewsNewBadge}>
      <Text style={styles.positiveReviewsNewBadgeText}>NEW</Text>
    </View>

    <View style={styles.positiveReviewsLeft}>
      <Ionicons
        name="download-outline"
        size={17}
        color="#111"
        style={{ marginRight: 8 }}
      />

      <Text style={styles.positiveReviewsText}>
        Download positive reviews
      </Text>
    </View>

    <View style={styles.positiveReviewsRight}>
      {userData.Username && !isAuthenticated && (
        <Ionicons
          name="lock-closed-outline"
          size={14}
          color="#111"
          style={{ marginRight: 6 }}
        />
      )}

      <Ionicons
        name="chevron-forward"
        size={16}
        color="#111"
      />
    </View>
  </TouchableOpacity>
)}



{/* === CLARA AI === */}
{userData?.Username && planStatusLoaded && isSubscriber && (
  <TouchableOpacity
    style={styles.claraMobileBar}
    activeOpacity={0.86}
    onPress={() => Linking.openURL('https://collabbayadmin.com/Clara')}
  >
    <View style={styles.claraMobileOrb}>
      <View style={styles.claraMobileOrbInner} />
      <View style={styles.claraMobileOrbDot} />
    </View>

    <View style={styles.claraMobileCopy}>
      <View style={styles.claraMobileTopLine}>
        <Text style={styles.claraMobileKicker}>
          AI INFLUENCER MANAGER
        </Text>

        <Text style={styles.claraMobileNew}>
          NEW
        </Text>
      </View>

      <Text style={styles.claraMobileTitle}>
        Meet <Text style={styles.claraMobileTitleAccent}>Clara™</Text>
      </Text>

      <Text style={styles.claraMobileSub}>
        Built into your Collabbay account
      </Text>
    </View>

    <Text style={styles.claraMobileArrow}>
      →
    </Text>
  </TouchableOpacity>
)}

{/* === Thin Google Reviews CTA === */}
{!loading && userData?.Username && (
  <TouchableOpacity
    style={styles.googleReviewBar}
    onPress={() => {
      if (!isAuthenticated) {
        // 🚀 Same as Browse Creators — send to subscribe page
        Linking.openURL('https://collabbayadmin.com/plans');
      } else {
        navigation.navigate('ReviewDashboard');
      }
    }}
  >
    {/* Google dots */}
    <View style={styles.googleDotsRow}>
      <View style={[styles.googleDot, { backgroundColor: 'black' }]} />
      <View style={[styles.googleDot, { backgroundColor: 'black' }]} />
      <View style={[styles.googleDot, { backgroundColor: 'black' }]} />
      <View style={[styles.googleDot, { backgroundColor: 'black' }]} />

    </View>

    <Text style={styles.googleReviewText}>Get Google reviews</Text>

    {/* 🔒 Lock overlay if logged in but not subscribed */}
    {userData.Username && !isAuthenticated && (
      <Ionicons
        name="lock-closed-outline"
        size={14}
        color="black"
        style={{ marginLeft: 6 }}
      />
    )}


  </TouchableOpacity>
)}


          <View style={styles.bottomBackground}>
          {userData.Username ? ( 
  <View style={styles.header}>
    {userData.Username ? `` : ''}
  </View>
) : (
  <View style={styles.header}>
    <TouchableOpacity onPress={() => window.location.href = 'https://collabbayadmin.com/SignIn'}>
      <Text
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          color: '#000',
          backgroundColor: '#fff', // White background
          padding: 7, // Padding around the text
          borderRadius: 17, // Rounded borders
          borderWidth: 1, // Border width
          borderColor: '#fdf05d', // Border color
          textAlign: 'center', // Center the text
          overflow: 'hidden', // Ensures rounded borders
          display: 'flex', // Enables flex layout
          flexDirection: 'row', // Aligns icon and text horizontally
          alignItems: 'center', // Vertically centers the items
          marginTop: 20,
        }}
      >
        <Ionicons name="log-in-outline" size={20} color="#000" style={{ marginRight: 8 }} />
        Log in or create an account
      </Text>
    </TouchableOpacity>
  </View>
)}


            

{userData.Username && suggestedUsers.length > 0 && (
  <View style={{ width: '98%', alignSelf: 'center', marginTop: 2 }}>

    <View style={{ width: '99%', alignSelf: 'center', marginTop: 20 }}>
      {loadingSuggested ? (
        <ActivityIndicator size="large" color="#000" />
      ) : (
<ScrollView
          horizontal
          showsHorizontalScrollIndicator={Platform.OS === 'web'} // ✅ Show scrollbar on PC
          contentContainerStyle={{ paddingRight: 10 }}
          style={{
            overflow: Platform.OS === 'web' ? 'scroll' : 'hidden',
          }}
        >
          {/* ✅ FIRST CARD IS THE TITLE CARD */}

          
          <View
            style={{
              backgroundColor: 'white',
              borderRadius: 12,
              marginRight: 10,
              flexDirection: 'row',
              alignItems: 'center',
              paddingVertical: 6,
              paddingHorizontal: 10,
              height: 65,
              minWidth: 250,
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 1 },
              shadowOpacity: 0.1,
              shadowRadius: 2,
            }}
          >
            <Ionicons
              name="arrow-forward-circle-outline"
              size={28}
              color="black"
              style={{ marginRight: 10 }}
            />
            <View style={{ flex: 1 }}>
              <Text style={{
                fontWeight: 'bold',
                fontSize: 14,
                marginBottom: 2,
              }} numberOfLines={1}>
                Suggested influencers...
              </Text>
              <Text style={{
                fontSize: 12,
                color: '#666',
              }} numberOfLines={1}>
                Scroll right to invite creators.
              </Text>
            </View>
          </View>

          {/* ✅ USER CARDS */}
          {suggestedUsers.map((user, index) => (
            <TouchableOpacity
              key={index}
              style={{
                backgroundColor: 'white',
                borderRadius: 12,
                marginRight: 10,
                flexDirection: 'row',
                alignItems: 'center',
                paddingVertical: 6,
                paddingHorizontal: 10,
                height: 65,
                minWidth: 200,
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.1,
                shadowRadius: 2,
              }}
              onPress={() => {
                const subject = `Collab invite from ${userData.Username}`;
                const body = `Hi ${user.Username},\n\nWe'd love to collaborate with you on Collabbay! Check out our offer and let us know if you're interested.\n\You can visit Collabbay to check it out and book to visit us.\n\nThanks,\n${userData.Username}`;
                
                const mailto = `mailto:${user.UserEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                
                Linking.openURL(mailto).catch(err => console.error('Failed to open email client:', err));
              }}
              
            >
              {/* PROFILE IMAGE */}
              <Image
                source={{ uri: user.ProfileImage }}
                style={{
                  width: 45,
                  height: 45,
                  borderRadius: 22.5,
                  backgroundColor: '#ccc',
                  marginRight: 8,
                }}
              />

              {/* USER INFO */}
              <View style={{ flex: 1, justifyContent: 'center' }}>
                <Text style={{
                  fontWeight: '600',
                  fontSize: 13,
                  marginBottom: 2,
                }} numberOfLines={1}>
                  {user.Username}
                </Text>

                <Text style={{
                  fontSize: 12,
                  color: '#666',
                }} numberOfLines={1}>
                  {user.PlatformFollowers} followers
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}
    </View>

  </View>
)}




 {/* Dashboard Section */}
<View style={styles.section}>
  <View style={styles.cardRow}>
    {/* My Offers Button */}
    <TouchableOpacity
      style={[styles.card, styles.clickableCard]}
      onPress={() => navigation.navigate('BrandListingsDashboard')}
    >
      <Ionicons name="laptop" size={35} color="white" />
      <Text style={styles.cardTitle}>My Offers</Text>
      <Text style={styles.cardSubText}>Go to Dashboard</Text>
    </TouchableOpacity>

    {/* Browse All Creators (replacing QR scan) */}
   

<TouchableOpacity
  style={[styles.card, styles.clickableCard]}
  onPress={() => navigation.navigate('BrowseInviteCreators')}
>


  <Ionicons name="search" size={35} color="white" />


  <Text style={styles.cardTitle}>Browse Creators</Text>
  <Text style={styles.cardSubText}>Search & Invite</Text>
</TouchableOpacity>


  </View>
</View>




     {showAlertSymbol && (
  <TouchableOpacity onPress={handleAlertPress} style={{ flexDirection: 'row', alignItems: 'center' }}>
    <Ionicons name="alert-circle" size={50} color="fdf05d" />
    <Text
  style={{
    marginLeft: 8,
    fontSize: 25,
    color: 'black',
    fontWeight: 'bold', // Fixed typo here
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 8, // Rounded border
  }}
>Influencer at your venue now? Click here.
</Text>
    
  </TouchableOpacity>
)}




{currentCollab && (
  <Modal
    visible={showCollabModal}
    transparent
    animationType="slide"
    onRequestClose={() => setShowCollabModal(false)}
  >
    <View style={styles.modalOverlay}>
      <View style={styles.modalContent}>
        {/* Close Button */}
        <TouchableOpacity
          style={styles.closeButton}
          onPress={() => setShowCollabModal(false)}
        >
          <Ionicons name="close" size={24} color="black" />
        </TouchableOpacity>

        {/* Modal Title */}
        <Text style={styles.modalTitle}>Are you collabing now?</Text>

        {/* Modal Message */}
        <Text style={styles.modalMessage}>
          You have an upcoming collab with{' '}
          <Text style={{ fontWeight: 'bold' }}>{currentCollab.BrandName}</Text>.
        </Text>

        {/* Collab Instructions */}
        <View style={styles.instructionList}>
          <Text style={styles.instructionHeader}>

          </Text>


          <View>
  <Text style={[styles.instructionItem, { marginBottom: 10 }]}>
    • 1. Welcome the creator. 👋
  </Text>
  <Text style={[styles.instructionItem, { marginBottom: 10 }]}>
    • 2. Provide the agreed offer or service. 🎉
  </Text>
  <Text style={[styles.instructionItem, { marginBottom: 10 }]}>
    • 3. The creator will begin to prepare their content. 🔗
  </Text>
  <Text style={[styles.instructionItem, { marginBottom: 10 }]}>
    • 4. Scan the creator's QR code before they leave to confirm their visit. 🗺
  </Text>
  <Text style={[styles.instructionItem, { marginBottom: 10 }]}>
    • 5. Await the creator's content upload to Collabbay as per the agreed timeline. 📤
  </Text>
</View>



        </View>

        {/* Navigate to Collab Button */}
        <TouchableOpacity
          style={styles.modalButton}
          onPress={handleCollabNavigate}
        >
          <Text style={styles.modalButtonText}>Go to {currentCollab.Promoter} Collab</Text>
        </TouchableOpacity>
      </View>
    </View>
  </Modal>
)}


            {/* Upcoming Collabs Section */}

            {userData.Username && (
  <>



<View
  nativeID="my-requests-section"
  style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: '3%', marginVertical: 5 }}
>

  <Text style={{ fontSize: 25, fontWeight: 'bold', textAlign: 'left', marginBottom: 10, marginLeft: 15 }}>
    My requests
  </Text>

  {/* WRAPPER so we can absolutely-position the bubble */}
  <View style={styles.allCollabsWrap}>


    <TouchableOpacity
      style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#fdf05d', borderRadius: 12, paddingVertical: 6, paddingHorizontal: 10 }}
      onPress={() => navigation.navigate('BrandListingsDashboard')}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff', borderRadius: 999, paddingVertical: 6, paddingHorizontal: 12 }}>
        <Text style={{ fontSize: 14, fontWeight: '700', color: 'black', marginRight: 8 }}>All collabs</Text>
        <View style={{ backgroundColor: 'black', borderRadius: 999, minWidth: 24, paddingVertical: 2, paddingHorizontal: 8, alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ color: 'white', fontSize: 19, fontWeight: '700' }}>
            {typeof totalCollabCount === 'number' ? totalCollabCount : 0}
          </Text>
        </View>
      </View>
      <Ionicons name="arrow-forward" size={20} color="black" style={{ marginLeft: 8 }} />
    </TouchableOpacity>

    {/* 🎈 mini speech bubble (tap to dismiss) */}
    {showAudienceBubble && (
      <TouchableOpacity
        activeOpacity={0.9}
        onPress={() => setShowAudienceBubble(false)}
        style={styles.audienceBubble}
      >
        <Text style={styles.audienceBubbleText}>
          Combined audience so far:
        </Text>
        <Text style={styles.audienceBubbleNumber}>
          {formatHuman(audienceCount)}
        </Text>
        <View style={styles.audienceBubbleTail} />
      </TouchableOpacity>
    )}
  </View>
</View>


<View style={styles.section}>



{/* === PSYCHE MOMENT POPUP (MESSAGE / ALERT STYLE) === */}

{userData.Username && !isAuthenticated && showPsychePopup && (
  <TouchableOpacity
    onPress={() => {
      setShowPsychePopup(false);
      Linking.openURL("https://collabbayadmin.com/plans");
    }}
    style={{
      backgroundColor: "#ffffff",
      paddingVertical: 14,
      paddingHorizontal: 18,
      borderRadius: 18,
      marginHorizontal: 15,
      marginBottom: 12,
      flexDirection: "row",
      alignItems: "center",

      // Message card shadow
      shadowColor: "#000",
      shadowOpacity: 0.12,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: 4 },

      borderWidth: 1,
      borderColor: "#e4e4e7",

      // Subtle “priority” stripe
      borderLeftWidth: 4,
      borderLeftColor: "#FDF05D",
    }}
  >
    {/* Alert icon */}
    <View
      style={{
        width: 34,
        height: 34,
        borderRadius: 17,
        borderWidth: 1,
        borderColor: "#e4e4e7",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 12,
        backgroundColor: "#fafafa",
      }}
    >
      <Ionicons
        name="notifications-outline"
        size={19}
        color="#000"
      />
    </View>

    {/* Message copy + badge */}
    <View style={{ flex: 1 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 2,
        }}
      >
        <Text
          style={{
            color: "#000",
            fontSize: 15,
            fontWeight: "700",
          }}
          numberOfLines={1}
        >
          Boost your business?
        </Text>

        {/* "1 new" notification badge */}
        <View
          style={{
            marginLeft: 8,
            paddingHorizontal: 8,
            paddingVertical: 2,
            borderRadius: 999,
            backgroundColor: "#000",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              color: "#4CD964",
              fontSize: 11,
              fontWeight: "800",
            }}
          >
            1 new
          </Text>
        </View>
      </View>

      <Text
        style={{
          color: "#555",
          fontSize: 13,
          fontWeight: "500",
        }}
        numberOfLines={1}
      >
        View your forecast
      </Text>
    </View>
  </TouchableOpacity>
)}



  {loading ? (
    <ActivityIndicator size="large" color="black" /> // Show a loading spinner while data is being fetched
  ) : (
  collabs.length === 0 ? (
  <View style={{ width: '90%', alignSelf: 'center', marginTop: 10 }}>
    {/* Header row */}
  
      <View
      style={{
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        marginBottom: 10,
      }}
    />
    <TouchableOpacity
      onPress={() => setShowUpcomingTip(!showUpcomingTip)}
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 10,
      }}
    >
      <Text style={{ fontSize: 16, fontWeight: '600', color: 'black' }}>
        No upcoming bookings?
      </Text>
      <Ionicons
        name={showUpcomingTip ? 'chevron-up' : 'chevron-down'}
        size={20}
        color="black"
      />
    </TouchableOpacity>

    {/* Thin divider line below */}


    {/* Collapsible content */}
    {showUpcomingTip && (
      <View style={styles.emptyStateCard}>
        <View style={styles.tipRow}>
          <Ionicons name="bulb-outline" size={18} color="black" style={styles.tipIcon} />
          <Text style={styles.tipText}>
            Get ready for your next collab. Don’t wait—take ownership and create momentum.
          </Text>
        </View>

        <View style={styles.tipBubble}>
          <Text style={styles.tipBubbleTitle}>Two quick wins</Text>
          <Text style={styles.tipBullet}>• Invite relevant creators directly.</Text>
          <Text style={styles.tipBullet}>• Improve your offer to attract more interest.</Text>
          <View style={styles.tipTail} />
        </View>

        <View style={styles.ctaRow}>
          <TouchableOpacity
            style={[styles.ctaButton, styles.ctaPrimary]}
            onPress={() => {
              if (userData?.Username && !isAuthenticated) {
                Linking.openURL('https://collabbayadmin.com/plans');
              } else {
                navigation.navigate('BrowseInviteCreators');
              }
            }}
          >
            <Ionicons name="search" size={16} color="black" style={{ marginRight: 6 }} />
            <Text style={styles.ctaText}>Browse & Invite Creators</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.ctaButton, styles.ctaSecondary]}
            onPress={() => Linking.openURL('https://collabbayadmin.com/Guide')}
          >
            <Ionicons name="create-outline" size={16} color="black" style={{ marginRight: 6 }} />
            <Text style={styles.ctaText}>Improve Your Offer</Text>
          </TouchableOpacity>
        </View>

        <Text style={styles.helperLine}>
          Requests will appear here once you start taking action.
        </Text>
      </View>
    )}
  </View>
)
 : (

      <>
        {collabs.length > 100 && (
          <ActivityIndicator size="large" color="#0000ff" style={{ marginVertical: 10 }} />
        )}

{displayCollabs.map((collab, index) => {
  const status = getCollabStatus(collab);
  const isProposal = String(collab?.IsProposal || '').toUpperCase() === 'Y';
  const shouldBlurName = !isAuthenticated && index !== 0; // only first visible card is free
  const daysLeft = getDaysUntil(collab.CreditAvailableStart);

const isUnseen =
  String(collab?.HasBrandSeenOffer || '').trim().toUpperCase() !== 'Y';

  // ✅ Fallback logic for follower data
  const followerString =
    collab?.PlatformFollowers ||
    collab?.Followers ||
    collab?.PromoterFollowers ||
    '';

  const followerNumber = parseFollowers(followerString);

  return (
    <TouchableWithoutFeedback
      key={collab?.CollabID ?? index}
   onPress={() => {
  if (showMenuIndex !== index) {
    handleCardPress(collab.CollabID, index, collab.Promoter);
  }
  setShowMenuIndex(null);
}}

      onStartShouldSetResponder={() => showMenuIndex !== null}
    >


<View
  style={[
    styles.collabCard,
    !isAuthenticated && index === 0 && styles.unlockedCard,
    isProposal && styles.proposalCard,
  ]}
>

{isUnseen && (
  <View style={styles.unseenRequestBadge}>
    <Text style={styles.unseenRequestBadgeText}>1</Text>
  </View>
)}

 {/* 🔔 Expiry badge for non-subscribed users */}
        {!isAuthenticated && (
          <View style={styles.expiryBadge}>
            <Ionicons
              name="time-outline"
              size={11}
              color="white"
              style={{ marginRight: 4 }}
            />
            <Text style={styles.expiryBadgeText}>
              Expires in {daysLeft} days
            </Text>
          </View>
        )}

        
        {!isAuthenticated && index === 0 && (
          <View style={styles.freeBadge}>
            <Ionicons name="flash-outline" size={14} color="#fff" style={{ marginRight: 4 }} />
            <Text style={styles.freeBadgeText}>Unlocked for you</Text>
          </View>
        )}

      
 
 {isProposal && (
  <View style={styles.proposalBadge}>
    <View style={styles.proposalBadgeIcon}>
      <Text style={styles.proposalBadgeIconText}>✦</Text>
    </View>

    <Text style={styles.proposalBadgeText}>
      Proposal
    </Text>
  </View>
)}





{status === 'Pending' && (
  <TouchableOpacity
    activeOpacity={0.7}
    disabled={hidingCollabID === collab.CollabID}
    style={[
      styles.notInterestedButton,
      hidingCollabID === collab.CollabID && {
        opacity: 0.5,
      },
    ]}
    onPress={(e) => {
      e.stopPropagation();
      handleNotInterested(collab.CollabID);
    }}
  >
    {hidingCollabID === collab.CollabID ? (
      <ActivityIndicator
        size="small"
        color="#555"
        style={{ marginRight: 5 }}
      />
    ) : (
      <Ionicons
        name="eye-off-outline"
        size={14}
        color="#555"
        style={{ marginRight: 5 }}
      />
    )}

    <Text style={styles.notInterestedText}>
      {hidingCollabID === collab.CollabID
        ? 'Hiding...'
        : 'Hide?'}
    </Text>
  </TouchableOpacity>
)}



<Ionicons name="calendar" size={24} color="black" style={styles.icon} />
<Text style={styles.collabCardTitle}>{formatDate(collab.CreditAvailableStart)}</Text>


        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text style={styles.collabCardSubTitle}></Text>
          <View style={[getStatusStyle(status), { flexDirection: 'row', alignItems: 'center' }]}>
            {getStatusIcon(status)}
            <Text style={{ color: 'black', marginLeft: 4 }}>{status}</Text>
          </View>
        </View>

        {/* === PROMOTER ROW === */}
        <View style={styles.promoterRow}>
          <Image
            source={{
              uri:
                (collab?.PromoterProfileImage && collab.PromoterProfileImage.trim() !== '')
                  ? collab.PromoterProfileImage
                  : 'https://collabbayadmin.com/defaults/avatar-placeholder.png',
            }}
            style={styles.promoterAvatarLarge}
          />

          <View>
            {/* ✅ Promoter name (blurred if not authenticated) */}
            <Text style={styles.promoterName}>
              {shouldBlurName ? (
                <>
                  {(collab?.Promoter ?? '').charAt(0)}
                  <Text style={styles.blurredText} selectable={false}>
                    {(collab?.Promoter ?? '').slice(1)}
                  </Text>
                </>
              ) : (
                collab?.Promoter ?? ''
              )}
            </Text>

            {/* ✅ Followers badge (now guaranteed visible if any data exists) */}
            {followerString ? (
              <View
                style={{
                  backgroundColor: '#f3f3f3',
                  borderRadius: 10,
                  paddingVertical: 3,
                  paddingHorizontal: 8,
                  alignSelf: 'flex-start',
                  marginTop: 4,
                }}
              >
                <Text style={{ fontSize: 12, color: '#333', fontWeight: '600' }}>
                 {getFollowerRange(followerNumber)}
                </Text>
              </View>
            ) : (
              <Text style={{ fontSize: 11, color: '#999', marginTop: 4 }}>—</Text>
            )}
          </View>
        </View>

        {/* === OFFER BUBBLE === */}
        <Text style={{ marginTop: 15, marginBottom: 6 }}>
          <Text
            style={{
              backgroundColor: '#f3f3f3',
              paddingVertical: 6,
              paddingHorizontal: 10,
              borderRadius: 16,
              alignSelf: 'flex-start',
              fontSize: 13,
            }}
          >
            {collab?.NonCreditOffer?.length > 40
              ? collab.NonCreditOffer.substring(0, 40) + '…'
              : collab?.NonCreditOffer ?? ''}
          </Text>
        </Text>

        {/* === ON BEHALF OF SECTION === */}
        {collab?.OnBehalfOf && collab.OnBehalfOf.trim() !== '' && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'flex-start',
              marginTop: 4,
              backgroundColor: '#fff',
              paddingVertical: 6,
              paddingHorizontal: 10,
              borderRadius: 15,
              borderWidth: 1,
              borderColor: '#ccc',
            }}
          >
            <Text style={{ fontSize: 11, fontWeight: 'bold', color: '#333', marginRight: 5 }}>
              Client |
            </Text>
            <Text style={{ fontSize: 16, color: '#333', fontWeight: '600' }}>
              {collab.OnBehalfOf}
            </Text>
            <Ionicons name="person-circle-outline" size={18} color="#555" style={{ marginLeft: 6 }} />
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
})}






      </>
    )
  )}

  

  {/* === MISSED / EXPIRED REQUESTS === */}
<View style={{ marginTop: 12, marginBottom: 40 }}>
  <View
    style={{
      borderTopWidth: 1,
      borderTopColor: '#ddd',
      marginVertical: 15,
      width: '90%',
      marginLeft: 17,
      alignSelf: 'center',
    }}
  />


<View style={{ marginBottom: 10, marginLeft: 19 }}>
  <Text
    style={{
      fontSize: 22,
      fontWeight: 'bold',
      color: 'black',
      marginBottom: 6,
    
    }}
  >
    Missed these requests?
  </Text>

  {!loadingMissed && missedCollabs.length > 0 && (
    <View
      style={{
        alignSelf: 'flex-start',
        backgroundColor: 'rgba(0,0,0,0.05)', // slight dark translucent background
        paddingVertical: 4,
        paddingHorizontal: 10,
        borderRadius: 10,
      }}
    >
      <Text style={{ fontSize: 14, fontWeight: '600', color: '#333' }}>
        {formatHumanFollowers(missedFollowerSum)} Followers
      </Text>
    </View>
  )}
</View>




<Text
  style={{
    fontSize: 13,
    color: '#666',
    marginTop: 3,
    marginLeft: '5%',
    marginRight: '5%',
  }}
>
  These creators sent requests you didn’t accept — don't worry! You can move them to a future date.
</Text>


  {loadingMissed ? (
    <ActivityIndicator size="large" color="black" />
  ) : missedCollabs.length === 0 ? (
    <Text style={{ textAlign: 'center', color: '#888', marginBottom: 10 }}>
      No missed requests 🎉
    </Text>
  ) : (
    missedCollabs.map((c, i) => {
      const isLocked = !isAuthenticated;

      return (
        <TouchableOpacity
          key={i}
          onPress={() => {
            if (isLocked) {
              Linking.openURL('https://collabbayadmin.com/plans'); // ✅ Opens subscribe HTML page
            } else {
              navigation.navigate('SingleCollabMetrics', { CollabID: c.CollabID });
            }
          }}
          activeOpacity={0.8}
          style={[
            styles.collabCard,
            {
              backgroundColor: '#f9f9f9',
              borderColor: '#eee',
              borderWidth: 1,
            },
          ]}
        >
          {/* Date + status */}
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Ionicons name="time-outline" size={20} color="black" style={{ marginRight: 8 }} />
              <Text style={styles.collabCardTitle}>{formatRelativeDate(c.CreditAvailableStart)}</Text>
            </View>
            <View
              style={{
                backgroundColor: '#999',
                paddingVertical: 4,
                paddingHorizontal: 8,
                borderRadius: 10,
              }}
            >
              <Text style={{ color: 'white', fontSize: 12, fontWeight: '600' }}>Expired</Text>
            </View>
          </View>

          {/* Creator (blurred if locked) */}
          <View style={styles.promoterRow}>
            <Image
              source={{
                uri:
                  c.PromoterProfileImage && c.PromoterProfileImage.trim() !== ''
                    ? c.PromoterProfileImage
                    : 'https://collabbayadmin.com/defaults/avatar-placeholder.png',
              }}
              style={[
                styles.promoterAvatarLarge,
                isLocked && { opacity: 0.3 },
              ]}
            />
       <View style={{ flexDirection: 'column' }}>
  <Text style={styles.promoterName}>
    {isLocked ? (
      <>
        {(c.Promoter ?? '').charAt(0)}
        <Text style={styles.blurredText} selectable={false}>
          {(c.Promoter ?? '').slice(1)}
        </Text>
      </>
    ) : (
      c.Promoter
    )}
  </Text>

  {/* Followers badge BELOW name */}
  <View
    style={{
      backgroundColor: '#f3f3f3',
      borderRadius: 10,
      paddingVertical: 3,
      paddingHorizontal: 8,
      marginTop: 4,
      alignSelf: 'flex-start',
      maxWidth: 120, // ✅ stops badge going too wide
    }}
  >
    <Text style={{ fontSize: 12, color: '#333', fontWeight: '600' }}>
      {getFollowerRange(parseFollowers(c.PlatformFollowers))}
    </Text>
  </View>
</View>


          </View>

          {/* Offer */}
          {c.NonCreditOffer && (
            <Text
              style={{
                backgroundColor: '#eee',
                paddingVertical: 6,
                paddingHorizontal: 10,
                borderRadius: 16,
                alignSelf: 'flex-start',
                fontSize: 13,
                color: '#222',
                marginTop: 10,
              }}
            >
              {c.NonCreditOffer.length > 60
                ? c.NonCreditOffer.substring(0, 60) + '…'
                : c.NonCreditOffer}
            </Text>
          )}


{/* ✅ Client (OnBehalfOf) Tag */}
{c.OnBehalfOf && c.OnBehalfOf.trim() !== '' && (
  <View
    style={{
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      marginTop: 6,
      backgroundColor: '#fff',
      paddingVertical: 6,
      paddingHorizontal: 10,
      borderRadius: 15,
      borderWidth: 1,
      borderColor: '#ccc',
    }}
  >
    <Text style={{ fontSize: 11, fontWeight: 'bold', color: '#333', marginRight: 5 }}>
      Client |
    </Text>
    <Text style={{ fontSize: 16, color: '#333', fontWeight: '600' }}>
      {c.OnBehalfOf}
    </Text>
    <Ionicons name="person-circle-outline" size={18} color="#555" style={{ marginLeft: 6 }} />
  </View>
)}


          {/* Move to future date */}
          <TouchableOpacity
            onPress={() =>
              isLocked
                ? Linking.openURL('https://collabbayadmin.com/plans')
                : navigation.navigate('RescheduleCollab', { CollabID: c.CollabID })
            }
            style={{
              backgroundColor: '#e6e6e6',
              borderRadius: 10,
              marginTop: 12,
              paddingVertical: 8,
              alignItems: 'center',
            }}
          >
            <Text style={{ color: '#333', fontWeight: '600' }}>Move to a future date?</Text>
          </TouchableOpacity>
        </TouchableOpacity>
      );
    })
  )}
</View>




</View>


  </>
)}

  


        {/* <TouchableOpacity onPress={() => Linking.openURL('https://collabbay.com/PrivacyPolicy.html')}>
          <Text style={styles.linkText}> By using collabbay, you agree to our Privacy Policy and Terms of Use. </Text>
        </TouchableOpacity> */}

        </View>
        </View>
      </View>

      

      <View style={styles.footer}>
      <TouchableOpacity
  style={styles.footerIcon}
  onPress={() => {
    if (!userData.Username) {
      // Not logged in — do nothing
      return;
    }

    if (!isAuthenticated) {
      Linking.openURL('https://collabbayadmin.com/plans');
    } else {
      navigation.navigate('BrandActivityFeed');
    }
  }}
>

 


  <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />

  {/* 🔒 Show lock icon only if logged in and not subscribed */}
  {userData.Username && !isAuthenticated && (
    <View
      style={{
        position: 'absolute',
        top: -3,
        right: -3,
        backgroundColor: '#fdf05d',
        borderRadius: 10,
        padding: 2,
      }}
    >
      <Ionicons name="lock-closed-outline" size={12} color="black" />
    </View>
  )}
</TouchableOpacity>


{userData.Username ? (
  <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('BusinessAccountPage')}>
    <Ionicons name="person" size={24} color="black" />
  </TouchableOpacity>
) : (
  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => window.location.href = 'https://collabbayadmin.com/SignIn'}
  >
    <Ionicons name="person" size={24} color="black" />
  </TouchableOpacity>
)}


        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('BusinessHomepage')}>
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>

        <TouchableOpacity
  style={styles.footerIcon}
  onPress={() => {
    if (!userData.Username) {
      // Not logged in — do nothing
      return;
    }

    if (!isAuthenticated) {
      Linking.openURL('https://collabbayadmin.com/plans');
    } else {
      navigation.navigate('CollabCalendar');
    }
  }}
>
  <Ionicons name="calendar" size={24} color="black" />

  {/* 🔒 Show lock icon only if logged in and not subscribed */}
  {userData.Username && !isAuthenticated && (
    <View
      style={{
        position: 'absolute',
        top: -3,
        right: -3,
        backgroundColor: '#fdf05d',
        borderRadius: 10,
        padding: 2,
      }}
    >
      <Ionicons name="lock-closed-outline" size={12} color="black" />
    </View>
  )}
</TouchableOpacity>


        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CreateBrandListingChoice')}>
          <Ionicons name="add" size={24} color="black" />
        </TouchableOpacity>
      </View>
      
{renderEasyListModal()}


      {renderTutorial()}


      {showLoginPrompt && !userData.Username && (
  <Modal
    transparent
    animationType="fade"
    visible={true}
    onRequestClose={() => setShowLoginPrompt(false)}
  >
    <View style={styles.modalOverlay}>
      <View style={styles.authPromptModal}>
        <TouchableOpacity
          onPress={() => setShowLoginPrompt(false)}
          style={styles.authPromptClose}
        >
          <Ionicons name="close" size={22} color="black" />
        </TouchableOpacity>

<Text style={styles.authPromptTitle}>
  Join collabbay
  <Text style={{ fontSize: 10 }}>©</Text>
  {' '}for Business
  <Text style={{ color: '#fdf05d' }}>.</Text>
</Text>

<Text style={styles.authPromptSub}>
  Access 29m+ combined followers and <Text style={{ fontWeight: 'bold' }}>700+</Text> creators. <Text style={{ fontWeight: 'bold' }}>You're a few clicks away</Text>—start posting offers and accept creator bookings today.
</Text>


        <View style={styles.authOptionWrapper}>
          <Text style={styles.authPromptLabel}>Already have an account?</Text>
          <TouchableOpacity
            style={styles.authOptionCard}
            onPress={() => Linking.openURL('https://collabbayadmin.com/SignIn')}
          >
            <Ionicons name="log-in-outline" size={20} color="black" style={{ marginRight: 12 }} />
            <Text style={styles.authOptionText}>Log In</Text>
          </TouchableOpacity>
        </View>

        <Text style={styles.orText}>or</Text>

        <View style={styles.authOptionWrapper}>
          <Text style={styles.authPromptLabel}>New to Collabbay?</Text>
          <TouchableOpacity
            style={styles.authOptionCard}
            onPress={() => Linking.openURL('https://collabbayadmin.com/SignUp')}
          >
            <Ionicons name="person-add-outline" size={20} color="black" style={{ marginRight: 12 }} />
            <Text style={styles.authOptionText}>Sign Up</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  </Modal>
)}

{showOfferPromptModal && !showTutorial && brandListings.length === 0 &&(

  <Modal
    transparent
    animationType="fade"
    visible={true}
    onRequestClose={() => setShowOfferPromptModal(false)}
  >
    <View style={styles.modalOverlay}>
      <View
        style={{
          backgroundColor: '#fdf05d',
          borderRadius: 20,
          padding: 25,
          width: '80%',
          maxWidth: 420,
          alignItems: 'center',
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.2,
          shadowRadius: 4,
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <TouchableOpacity
          onPress={() => {
            setShowOfferPromptModal(false);
            setDismissedOfferPromptModal(true);
          }}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            padding: 6,
            zIndex: 10,
          }}
        >
          <Ionicons name="close" size={20} color="black" />
        </TouchableOpacity>

        <Ionicons name="add-circle-outline" size={30} color="black" style={{ marginBottom: 10 }} />

        <Text style={{ color: 'black', fontWeight: 'bold', fontSize: 20, textAlign: 'center' }}>
        List your venue to start taking influencer bookings
        </Text>
        <Text style={{ color: 'black', fontSize: 14, marginTop: 5 }}>
          You're 2-5 mins away.
        </Text>

        <TouchableOpacity
          onPress={() => {
            setShowOfferPromptModal(false);
            navigation.navigate('GuidedOfferSetup');
          }}
          style={{
            marginTop: 15,
            backgroundColor: 'black',
            paddingVertical: 12,
            paddingHorizontal: 25,
            borderRadius: 10,
          }}
        >
          <Text style={{ color: 'white', fontWeight: 'bold' }}>Create an Offer</Text>
        </TouchableOpacity>
      </View>
    </View>
  </Modal>
)}



    </SafeAreaView>
    </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    width: '100%',
  },
  contentContainer: {
    paddingHorizontal: 10,
    alignItems: 'center',
    alignSelf: 'center',
    paddingTop: '5',
  },
  section: {
    marginBottom: 20,
  },
  loginText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'black',
  },
  bannerContainer: {
    marginBottom: 20,
    borderRadius: 10,
    minWidth: 350,
    marginTop: 30,
    paddingTop: 30,
    backgroundColor: 'black',
    width: '100%',
    height: 150,
  },
  promoterRow: {
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 6,
},

promoterAvatarLarge: {
  width: 80,
  height: 80,
  borderRadius: 20,
  marginRight: 10,
  backgroundColor: '#ddd',
},

promoterName: {
  fontSize: 16,
  fontWeight: '600',
  color: 'black',
},

  bannerImage: {
    width: '100%',
    height: '100%',
    borderRadius: 10,
  },
  cardRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginTop: 15,
  },
  card: {
    width: '48%',
    height: 110,
    backgroundColor: 'black',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    position: 'relative',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
    color: 'white',
    textAlign: 'center',
  },
  cardSubText: {
    fontSize: 10,
    textAlign: 'center',
    color: 'white',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: '#ffff',
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 10,
  },
  footerIcon: {
    alignItems: 'center',
  },
  cornerTopLeft: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 10,
    height: 10,
    borderTopLeftRadius: 10,
  },
  cornerTopRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 10,
    height: 10,
    borderTopRightRadius: 10,
  },
  cornerBottomLeft: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: 10,
    height: 10,
    borderBottomLeftRadius: 10,
  },
  cornerBottomRight: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 10,
    height: 10,
    borderBottomRightRadius: 10,
  },
  bottomBackground: {
    backgroundColor: '#FDF05D',
    borderRadius: 30,
    paddingHorizontal: 10,
    paddingHorizontal: 10,
    width: '92.5%', // Or set any specific maxWidth like '80%' depending on your design
    alignSelf: 'center', // Centers the container horizontally
marginBottom: '27%',  

  },
  linkText: {
    fontSize: 9,
    color: 'black',
    textDecorationLine: 'underline',
    textAlign: 'center',
    marginTop: 20,
    borderRadius: '10',
    padding: '5',
    marginBottom: 3,
  },
  sectionHeader: {
    fontSize: 24,
    fontWeight: 'bold',
    marginVertical: '1%',
    alignSelf: 'center',
  },

  calendarSectionHeader: {
    fontSize: 24,
    fontWeight: 'bold',
    marginVertical: '1%',
    alignSelf: 'left',
  },
  
  collabCard: {
    width: '94%',
    backgroundColor: 'white',
    borderRadius: 15,
    borderColor: '#f0e65b',       
    padding: 10,
    marginVertical: 5,
    alignSelf: 'center',
     position: 'relative',
  },
  unseenRequestBadge: {
  position: 'absolute',
  top: -7,
  right: -7,
  width: 22,
  height: 22,
  borderRadius: 999,
  backgroundColor: '#ef4444',
  borderWidth: 2,
  borderColor: '#ffffff',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 30,
  elevation: 6,
},

unseenRequestBadgeText: {
  color: '#ffffff',
  fontSize: 11,
  fontWeight: '800',
  lineHeight: 14,
},

expiryBadge: {
  position: 'absolute',
  top: 17,
  right: 95,
  backgroundColor: 'black',
  borderRadius: 10,
  paddingHorizontal: 6,
  paddingVertical: 3,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 15,
},
  expiryBadgeText: {
    fontSize: 10,
    color: 'white',
    fontWeight: '600',
  },

  
  collabCardTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5,
    color: 'black',
  },
  collabCardSubTitle: {
    fontSize: 15,
    color: 'black',
  },
  noCollabText: {
    fontSize: 9,
    color: 'black',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tutorialCard: {
  backgroundColor: '#0b0b0c', // ✅ Black background
  padding: 25,
  borderRadius: 14,
  alignItems: 'center',
  width: '85%',
  maxWidth: 420,
},
  iconLarge: {
    marginBottom: 15,
  },
  tutorialText: {
  fontSize: 16,
  color: '#fff',              // ✅ White text
  textAlign: 'center',
  lineHeight: 26,
},
  nextButton: {
    marginTop: 10,
    padding: 10,
    backgroundColor: '#000',
    borderRadius: 5,
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  redoButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: '#FDF05D', 
    padding: 6,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10, // Ensure it's above other elements
  },
  messageContainer: {
    padding: 10,                     // Maintain padding for spacing
    backgroundColor: '#f3f3f0',        // Set background to blac
    marginBottom: 10,
    marginTop: 10,          // Optional: White border for contrast             // Border width for rounded effect
    borderRadius: 10,                // Rounded corners
    width: '70%',            
    margintop: 10,        // Set width to 50% of screen
    alignSelf: 'center',             // Center horizontally
    justifyContent: 'center',        // Center vertically within flex container
    alignItems: 'center',            // Center text and content inside
    marginVertical: 'auto',          // Center vertically on the screen
  },
  messageText: {
    color: 'black',                   // Sets text color to white
    fontWeight: 'bold', // Underlines the text
    textAlign: 'center',              // Centers the text
    fontSize: 10,                     // Adjust font size as needed
    marginRight: 5,                   // Adds space between text and icon  
  },
welcomeText: {
    fontSize: 18,
    color: 'darkgrey',
},
headerRow: {
  flexDirection: 'row', // Horizontal alignment
  alignItems: 'center', // Vertically center items
  justifyContent: 'space-between', // Push items to sides
  width: '92.5%', // Full width of container
  paddingHorizontal: 1, // Add padding for spacing
  marginBottom: 7, // Optional: Adjust vertical spacing
  alignSelf: 'center', // Centers the container horizontally
marginTop: 10,
},

smallRoundedLogo: {
  width: 40, // Set width for small size
  height: 40, // Set height for small size
  borderRadius: 20, // Make it fully rounded
  backgroundColor: 'black', // Black background
  marginRight: 10,
  paddingLeft: 10, // Space between logo and text
},

headerText: {
  fontSize: 16, // Adjust font size
  fontWeight: 'bold', // Make it bold
  color: 'black', // Set text color
  flex: 1, // Allow text to take remaining space
  textAlign: 'left', // Align text to the right
  paddingLeft: 7,
},
cardScrollContainer: {
  marginTop: 20,
  paddingLeft: 7,
  marginBottom: 20,
  width: '100%', // Full width of the screen
  flexDirection: 'row', // Horizontal scrolling
  overflow: 'hidden', // Prevent content spilling out

},
videoCard: {
  width: 130,  
  height: 160, // Set the height of each card
  backgroundColor: 'black', // Fallback color for the card in case video fails
  marginRight: 15, // Space between the cards
  borderRadius: 10, // Rounded corners for the card
  justifyContent: 'center', // Center the video inside the card
  alignItems: 'center', // Center the video inside the card
  position: 'relative', // Ensure the video covers the card properly
},
videoBackground: {
  position: 'absolute', // Ensures the video is positioned inside the card
  top: 0,
  left: 0,
  width: '100%', // Make the video fill the card width
  height: '100%', // Make the video fill the card height
  borderRadius: 10, // Apply rounded corners to the video as wellS
  zIndex: 0, // Ensure the video stays behind other content
},
scrollableContainer: {
  width: '92.5%', // Or set any specific maxWidth like '80%' depending on your design
  alignSelf: 'center', // Centers the container horizontally
},
modalOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
},
modalContent: {
  backgroundColor: '#fff',
  padding: 20,
  borderRadius: 10,
  width: '80%',
  alignItems: 'center',
},
modalTitle: { fontSize: 18, fontWeight: 'bold', marginBottom: 10 },
modalMessage: { fontSize: 16, textAlign: 'center', marginBottom: 20 },
instructionList: { marginBottom: 20 },
instructionItem: { marginBottom: 10, fontSize: 14 },
modalButton: { backgroundColor: '#fdf05d', padding: 10, borderRadius: 5 },
modalButtonText: { fontWeight: 'bold', textAlign: 'center' },
alertContainer: { flexDirection: 'row', alignItems: 'center', marginVertical: 20 },
alertText: { marginLeft: 10, fontSize: 16, fontWeight: 'bold' },
modalOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
  justifyContent: 'center',
  alignItems: 'center',
},
subscriptionModal: {
  backgroundColor: 'white',
  padding: 20,
  borderRadius: 10,
  alignItems: 'center',
  justifyContent: 'center',
  width: '85%', // Adjust width as per your design
},
subscriptionIcon: {
  marginBottom: 15,
},
subscriptionTitle: {
  fontSize: 22,
  fontWeight: 'bold',
  marginBottom: 10,
  textAlign: 'center',
  color: 'black',
},
subscriptionMessage: {
  fontSize: 16,
  color: 'grey',
  textAlign: 'center',
  marginBottom: 20,
},
subscribeButton: {
  backgroundColor: '#FDF05D',
  paddingVertical: 15,
  paddingHorizontal: 20,
  borderRadius: 10,
  width: '100%',
  alignItems: 'center',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.2,
  shadowRadius: 5,
},
subscribeButtonText: {
  fontSize: 16,
  fontWeight: 'bold',
  color: 'black',
  textAlign: 'center',
},
modalOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
},
subscriptionModal: {
  backgroundColor: '#fff',
  padding: 20,
  borderRadius: 10,
  alignItems: 'center',
  width: '80%',
},
subscriptionIcon: {
  marginBottom: 20,
},
subscriptionTitle: {
  fontSize: 20,
  fontWeight: 'bold',
  marginBottom: 10,
  textAlign: 'center',
},
subscriptionMessage: {
  fontSize: 16,
  textAlign: 'center',
  marginBottom: 20,
},
subscribeButton: {
  backgroundColor: '#fdf05d',
  padding: 10,
  borderRadius: 5,
},
subscribeButtonText: {
  fontWeight: 'bold',
  textAlign: 'center',
},
  spinner: {
    marginVertical: 10, // Adds spacing above and below the spinner
    alignSelf: 'center', // Centers the spinner horizontally
  },
    spinner: {
    marginVertical: 10, // Adds spacing above and below the spinner
    alignSelf: 'center', // Centers the spinner horizontally
  },
  sectionHeader: {
  fontSize: 24,
  fontWeight: 'bold',
  marginBottom: 10,
},
spinner: {
  marginVertical: 10,
  alignSelf: 'center',
},
noCollabText: {
  fontSize: 16,
  color: 'black',
  textAlign: 'center',
  marginVertical: 10,
},
loadingContainer: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff', // Optional background color
},
optionButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  padding: 10,
  marginVertical: 5,
  borderRadius: 5,
},
optionButtonSelected: {
  backgroundColor: '#fdf05d',
},
optionIcon: {
  marginRight: 10,
},
optionLabel: {
  fontSize: 16,
  fontWeight: 'bold',
  color: 'black',
},
venueCodeCard: {
 marginBottom: 15,
  backgroundColor: '#f3f3f3', // Card background colour
  paddingHorizontal: 12, // Horizontal padding
  paddingVertical: 8, // Vertical padding
  borderRadius: 17, // Rounded corners
  borderWidth: 1, // Border for definition
  width: '%',
  marginLeft: '40',
  borderColor: '#f3f3f3', // Subtle border colour
  elevation: 2, // Shadow for depth
  flexDirection: 'row', // Align text and icon in a row
  alignItems: 'center', // Vertically centre-align content
  zIndex: 10, // Ensure it sits above other elements
},

venueCodeText: {
  fontSize: 15,
  color: '#000',
  fontWeight: '400',
},
boldText: {
  fontWeight: 'bold',
},
closeButton: {
  marginTop: 20,
  backgroundColor: 'black', // Black button
  paddingVertical: 10,
  paddingHorizontal: 20,
  borderRadius: 5,
  alignItems: 'center',
},
closeButtonText: {
  color: 'white', // White text
  fontWeight: 'bold',
  fontSize: 16,
  textAlign: 'center',
},


overlay: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'transparent',
  zIndex: 4,
},
venueCodeCardContent: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
},
notInterestedButton: {
  position: 'absolute',
  top: 7,
  right: 7,
  zIndex: 20,

  flexDirection: 'row',
  alignItems: 'center',

  paddingVertical: 6,
  paddingHorizontal: 9,

  backgroundColor: '#f7f7f7',

  borderRadius: 20,
  borderWidth: 1,
  borderColor: '#e8e8e8',
},

notInterestedText: {
  color: '#444',
  fontSize: 11,
  fontWeight: '600',
},
venueCodeLabel: {
  fontSize: 14,
  color: '#fff', // white text
  textAlign: 'center',
  marginBottom: 5,
  width: '65%',
},

venueCodeValue: {
  fontSize: 50,
  fontWeight: 'bold',
  color: '#fff',
  textAlign: 'center',
},

iconBottomCard: {
  position: 'absolute',
  bottom: 7,
  alignSelf: 'center',
},
clickableCard: {
  backgroundColor: '#000', // darker base for button-like appearance
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.2,
  shadowRadius: 4,
  elevation: 5,
  borderWidth: 1,
  borderColor: '#fdf05d',
},
authPromptModal: {
  backgroundColor: 'white',
  padding: 25,
  borderRadius: 20,
  width: '85%',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: 0.15,
  shadowRadius: 6,
  alignItems: 'flex-start',
  position: 'relative',
},

authPromptClose: {
  position: 'absolute',
  top: 12,
  right: 12,
  padding: 5,
  zIndex: 2,
},

authPromptTitle: {
  fontSize: 22,
  fontWeight: 'bold',
  color: 'black',
  marginBottom: 8,
  textAlign: 'left',
},

authPromptSub: {
  fontSize: 14,
  color: '#555',
  marginBottom: 20,
  textAlign: 'left',
},

authPromptLabel: {
  fontSize: 13,
  color: '#777',
  marginBottom: 5,
},

authOptionCard: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  borderRadius: 14,
  borderWidth: 1,
  borderColor: '#ccc',
  paddingVertical: 12,
  paddingHorizontal: 15,
  width: '100%',
  marginBottom: 10,
},

authOptionText: {
  fontSize: 16,
  fontWeight: '500',
  color: 'black',
},

authOptionWrapper: {
  width: '100%',
  marginBottom: 15,
},

orText: {
  alignSelf: 'center',
  fontSize: 13,
  color: '#888',
  marginVertical: 4,
},
recentlyOnlineCard: {
  backgroundColor: '#f3f3f3',
  borderRadius: 25,
  padding: 10,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '48%',
  marginLeft: '48%', // ⬅️ Push the card to the right
  marginBottom: 2,
  marginTop:17,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 2,
},


recentlyOnlineLabel: {
  fontSize: 11,
  color: '#333',
  fontWeight: '600',
  paddingLeft: 5,
},

avatarRow: {
  flexDirection: 'row',
  alignItems: 'center',
},

avatarWrapper: {
  width: 30,
  height: 30,
  borderRadius: 15,
  overflow: 'visible', // allow the green dot to pop out
  position: 'relative',
  backgroundColor: '#ddd',
},


avatarImage: {
  width: 30,
  height: 30,
  borderRadius: 15,
  backgroundColor: '#ccc',
},

greenDot: {
  width: 10,
  height: 10,
  borderRadius: 5,
  backgroundColor: '#4CD964',
  position: 'absolute',
  top: 0,
  left: -2,
  borderWidth: 2,
  borderColor: '#fff',
  zIndex: 999,
},


plusCountText: {
  marginLeft: 8,
  fontSize: 12,
  color: '#555',
  fontWeight: 'bold',
},
blurredText: {
  color: 'transparent',
  textShadowColor: 'rgba(0,0,0,0.3)',
  textShadowOffset: { width: 0, height: 0 },
  textShadowRadius: 4,
  // userSelect below only matters on web; harmless elsewhere
  userSelect: 'none',
},
unlockedCard: {
  borderWidth: 3,
  borderColor: '#4CD964',               // iOS green
  shadowColor: '#4CD964',
  shadowOffset: { width: 0, height: 10 },
  shadowOpacity: 0.35,
  shadowRadius: 16,
  elevation: 10,                        // Android/web elevation
},

freeBadge: {
  position: 'absolute',
  top: -8,
  left: 35,
  backgroundColor: '#4CD964',
  paddingHorizontal: 8,
  paddingVertical: 4,
  borderRadius: 12,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 10,
},

freeBadgeText: {
  color: '#fff',
  fontWeight: '700',
  fontSize: 12,
  letterSpacing: 0.3,
},

blurredText: {
  color: 'transparent',
  textShadowColor: 'rgba(0,0,0,0.35)',  // faux blur
  textShadowOffset: { width: 0, height: 0 },
  textShadowRadius: 6,
  // (web-only nicety; safe to include)
  userSelect: 'none',
},

/* ===== Wrapper for pill + Recently Online row ===== */
ctaRowWrap: {
  position: 'relative',
  width: '92.5%',
  alignSelf: 'center',
  minHeight: 75,
  marginTop: 12,
},

/* ===== Pill anchor (left half) ===== */
ctaPillAnchor: {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '46%',
  height: 65,
  zIndex: 1,
},

/* ===== Pill container ===== */
ctaPill: {
  flex: 1,
  borderRadius: 999,
  overflow: 'hidden',                 // clip BG layers to pill
  justifyContent: 'center',
  paddingHorizontal: 14,
  backgroundColor: 'rgba(255,255,255,0.9)',
  borderWidth: 1,
  borderColor: '#f3f3f3',
  elevation: 6,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: 0.16,
  shadowRadius: 8,
},
emptyStateCard: {
  backgroundColor: 'white',
  borderRadius: 18,
  padding: 14,
  marginTop: 10,
  width: '94%',
  alignSelf: 'center',
  shadowColor: '#000',
  shadowOpacity: 0.1,
  shadowRadius: 5,
  shadowOffset: { width: 0, height: 2 },
  elevation: 2,
},
tipRow: {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
},
tipIcon: {
  marginRight: 8,
},
tipText: {
  flex: 1,
  fontSize: 14,
  fontWeight: '700',
  color: 'black',
},
tipBubble: {
  alignSelf: 'flex-start',
  backgroundColor: '#fdf05d',
  borderRadius: 12,
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderWidth: 1,
  borderColor: '#000',
  marginTop: 4,
  position: 'relative',
},
tipBubbleTitle: {
  fontSize: 13,
  fontWeight: '800',
  color: 'black',
  marginBottom: 4,
},
tipBullet: {
  fontSize: 12,
  color: '#111',
  marginTop: 2,
},
tipTail: {
  position: 'absolute',
  left: 18,
  bottom: -6,
  width: 10,
  height: 10,
  backgroundColor: '#fdf05d',
  transform: [{ rotate: '45deg' }],
  borderLeftWidth: 1,
  borderBottomWidth: 1,
  borderColor: '#000',
},
ctaRow: {
  flexDirection: 'row',
  gap: 10,
  marginTop: 12,
},
ctaButton: {
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 12,
  paddingVertical: 10,
  borderWidth: 1,
},
ctaPrimary: {
  backgroundColor: '#fdf05d',
  borderColor: '#000',
},
ctaSecondary: {
  backgroundColor: '#fff',
  borderColor: '#ddd',
},
ctaText: {
  fontSize: 13,
  fontWeight: '700',
  color: 'black',
},
helperLine: {
  marginTop: 10,
  fontSize: 12,
  color: '#555',
},

/* ===== Visual “blur/gradient/glow” layers (RN-friendly) ===== */
ctaPillBg: {
  ...StyleSheet.absoluteFillObject,
  backgroundColor: 'rgba(253,240,93,0.55)', // soft yellow wash
},
ctaPillGlow: {
  position: 'absolute',
  width: 220, height: 220, borderRadius: 110,
  top: -90, left: -40,
  backgroundColor: 'rgba(253,240,93,0.6)',
  shadowColor: '#FDF05D',
  shadowOffset: { width: 0, height: 0 },
  shadowOpacity: 0.9,
  shadowRadius: 28,
},
ctaBlobA: {
  position: 'absolute',
  width: 140, height: 140, borderRadius: 70,
  right: -30, top: -40,
  backgroundColor: 'rgba(255,255,255,0.6)',
  shadowColor: '#fff',
  shadowOffset: { width: 0, height: 0 },
  shadowOpacity: 0.7,
  shadowRadius: 16,
},
ctaBlobB: {
  position: 'absolute',
  width: 120, height: 120, borderRadius: 60,
  right: 0, bottom: -50,
  backgroundColor: 'rgba(0,0,0,0.06)',
},
ctaSparkA: {
  position: 'absolute',
  width: 80, height: 80, borderRadius: 40,
  left: 30, bottom: -30,
  backgroundColor: 'rgba(255,255,255,0.35)',
},
ctaSparkB: {
  position: 'absolute',
  width: 60, height: 60, borderRadius: 30,
  left: 70, top: -20,
  backgroundColor: 'rgba(255,255,255,0.25)',
},

/* ===== Foreground content ===== */
ctaContent: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
},
ctaText: {
  fontSize: 14,
  fontWeight: '700',
  color: '#000',
},
ctaChevron: {
  marginLeft: 6,
},
googleReviewBar: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f3f3f3',   // light grey to stand out from black/yellow
  paddingVertical: 5,
  paddingHorizontal: 14,
  borderRadius: 16,
  marginHorizontal: '4%',
  marginTop: 9,
  marginBottom: 15,
  shadowColor: '#000',
  shadowOpacity: 0.05,
  shadowRadius: 3,
},
googleReviewText: {
  fontSize: 12,
  fontWeight: '600',
  color: '#000',
  marginHorizontal: 8,
},
googleDotsRow: {
  flexDirection: 'row',
  marginRight: 6,
},
googleDot: {
  width: 6,
  height: 6,
  borderRadius: 3,
  marginHorizontal: 1,
},
newBadgeSmall: {
  backgroundColor: '#fdf05d',
  paddingHorizontal: 6,
  paddingVertical: 2,
  borderRadius: 10,
  borderWidth: 1,
  borderColor: '#000',
  marginLeft: 8,
},
newBadgeText: {
  fontSize: 9,
  fontWeight: '800',
  color: '#000',
  letterSpacing: 0.3,
},

/* ===== NEW badge (overlapping top-right) ===== */
ctaNewBadge: {
  position: 'absolute',
  top: -8,
  right: -8,
  backgroundColor: '#fdf05d',
  paddingHorizontal: 8,
  paddingVertical: 2,
  borderRadius: 12,
  borderWidth: 1,
  borderColor: '#000',
  zIndex: 2,
},
ctaNewBadgeText: {
  fontSize: 10,
  fontWeight: '800',
  color: '#000',
  letterSpacing: 0.3,
},

allCollabsWrap: {
  position: 'relative',
},

audienceBubble: {
  position: 'absolute',
  right: -6,
  top: -46,                // sits above/right of the button
  backgroundColor: '#fff',
  borderRadius: 14,
  paddingVertical: 8,
  paddingHorizontal: 12,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.15,
  shadowRadius: 6,
  elevation: 5,
  zIndex: 10,
  borderWidth: 1,
  borderColor: '#eee',
},

audienceBubbleText: {
  fontSize: 11,
  color: '#444',
  marginBottom: 2,
},

audienceBubbleNumber: {
  fontSize: 16,
  fontWeight: '800',
  color: '#000',
},

audienceBubbleTail: {
  position: 'absolute',
  bottom: -5,
  right: 24,
  width: 10,
  height: 10,
  backgroundColor: '#fff',
  transform: [{ rotate: '45deg' }],
  borderLeftWidth: 1,
  borderTopWidth: 1,
  borderColor: '#eee',
},
segmentOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0,0,0,0.62)',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 18,
},
segmentCard: {
  width: '100%',
  maxWidth: 430,
  backgroundColor: '#fff',
  borderRadius: 28,
  padding: 24,
},
segmentKicker: {
  fontSize: 11,
  fontWeight: '900',
  color: '#6b7280',
  letterSpacing: 2,
  textTransform: 'uppercase',
  marginBottom: 8,
},
segmentTitle: {
  fontSize: 29,
  fontWeight: '900',
  color: '#111827',
},

segmentDots: {
  flexDirection: 'row',
  gap: 7,
  marginTop: 16,
  marginBottom: 18,
},
segmentDot: {
  width: 8,
  height: 8,
  borderRadius: 99,
  backgroundColor: '#e5e7eb',
},
segmentDotActive: {
  width: 24,
  backgroundColor: '#111827',
},
segmentQuestion: {
  fontSize: 17,
  fontWeight: '900',
  color: '#111827',
  marginBottom: 12,
},
segmentOption: {
  width: '100%',
  paddingVertical: 15,
  paddingHorizontal: 16,
  borderRadius: 16,
  borderWidth: 1,
  borderColor: '#e5e7eb',
  backgroundColor: '#fff',
  marginBottom: 10,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
},
segmentOptionSelected: {
  borderWidth: 2,
  borderColor: '#111827',
  backgroundColor: 'rgba(253,240,93,0.35)',
},
segmentOptionText: {
  flex: 1,
  fontSize: 14,
  fontWeight: '800',
  color: '#111827',
  paddingRight: 10,
},
segmentRight: {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 10,
},
segmentBadge: {
  backgroundColor: '#f3f3f3',
  borderWidth: 1,
  borderColor: '#e5e7eb',
  borderRadius: 999,
  paddingVertical: 5,
  paddingHorizontal: 10,
  fontSize: 11,
  fontWeight: '900',
  color: '#111827',
},
segmentRadio: {
  width: 18,
  height: 18,
  borderRadius: 99,
  borderWidth: 2,
  borderColor: '#d1d5db',
  backgroundColor: '#fff',
},
segmentRadioSelected: {
  borderWidth: 6,
  borderColor: '#111827',
},
segmentNextBtn: {
  backgroundColor: '#FDF05D',
  paddingVertical: 13,
  paddingHorizontal: 16,
  borderRadius: 999,
  alignItems: 'center',
  marginTop: 4,
},
segmentNextText: {
  color: '#000',
  fontWeight: '900',
},
segmentBackBtn: {
  borderWidth: 1,
  borderColor: 'rgba(15,23,42,0.16)',
  paddingVertical: 13,
  paddingHorizontal: 16,
  borderRadius: 999,
  alignItems: 'center',
},
segmentBackText: {
  color: '#111827',
  fontWeight: '800',
},
segmentButtonRow: {
  flexDirection: 'row',
  gap: 10,
  marginTop: 4,
},
segmentSummary: {
  backgroundColor: '#f9fafb',
  borderWidth: 1,
  borderColor: '#e5e7eb',
  borderRadius: 18,
  padding: 16,
  marginBottom: 12,
},
segmentSummaryText: {
  fontSize: 14,
  fontWeight: '700',
  color: '#111827',
  marginBottom: 6,
},
segmentError: {
  color: '#eb5757',
  fontWeight: '800',
  marginBottom: 10,
},
proposalCard: {
  borderWidth: 3,
  borderColor: '#2563eb',
  backgroundColor: '#eff6ff',
  shadowColor: '#2563eb',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.22,
  shadowRadius: 14,
  elevation: 8,
},

proposalBadge: {
  position: 'absolute',
  bottom: 10,
  right: 12,
  backgroundColor: '#2563eb',
  paddingLeft: 5,
  paddingRight: 10,
  paddingVertical: 5,
  borderRadius: 999,
  flexDirection: 'row',
  alignItems: 'center',
  zIndex: 25,
},
proposalBadgeIcon: {
  width: 18,
  height: 18,
  borderRadius: 9,
  backgroundColor: '#fff',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 6,
},

proposalBadgeIconText: {
  color: '#2563eb',
  fontSize: 11,
  fontWeight: '900',
  lineHeight: 14,
},
proposalBadgeText: {
  color: '#fff',
  fontWeight: '800',
  fontSize: 12,
  letterSpacing: 0.2,
},
freemiumOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0,0,0,0.55)',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 18,
},

freemiumModal: {
  width: '100%',
  maxWidth: 460,
  backgroundColor: '#fff',
  borderRadius: 24,
  padding: 22,
  position: 'relative',
  alignItems: 'center',
  borderWidth: 1,
  borderColor: 'rgba(17,24,39,0.08)',
},

freemiumClose: {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 30,
  height: 30,
  borderRadius: 999,
  backgroundColor: '#f3f3f3',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20,
},

freemiumCloseLocked: {
  opacity: 0.35,
},

freemiumCloseText: {
  fontSize: 20,
  fontWeight: '900',
  color: '#111827',
},

freemiumTitle: {
  fontSize: 24,
  lineHeight: 29,
  fontWeight: '700',
  color: '#111827',
  textAlign: 'center',
  marginBottom: 15,
  marginTop: 18,
},

freemiumTitleBold: {
  fontWeight: '900',
},

freemiumTryBtn: {
  width: '100%',
  borderRadius: 999,
  paddingVertical: 14,
  paddingHorizontal: 12,
  backgroundColor: '#dcfce7',
  alignItems: 'center',
  justifyContent: 'center',
},

freemiumBtnInner: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
},

freemiumBtnTick: {
  width: 18,
  height: 18,
  borderRadius: 999,
  backgroundColor: '#22c55e',
  alignItems: 'center',
  justifyContent: 'center',
},

freemiumBtnTickText: {
  color: '#fff',
  fontSize: 11,
  fontWeight: '900',
},

freemiumBtnText: {
  color: '#166534',
  fontSize: 14,
  fontWeight: '900',
  textAlign: 'center',
},

freemiumProof: {
  marginTop: 26,
  backgroundColor: '#f8fafc',
  borderWidth: 1,
  borderColor: '#e5e7eb',
  opacity: 0.72,
  borderRadius: 14,
  paddingVertical: 9,
  paddingHorizontal: 12,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
},

verifyTick: {
  width: 18,
  height: 18,
  borderRadius: 999,
  backgroundColor: '#1d9bf0',
  alignItems: 'center',
  justifyContent: 'center',
},

verifyTickText: {
  color: '#fff',
  fontSize: 11,
  fontWeight: '900',
},

freemiumProofText: {
  fontSize: 12,
  fontWeight: '700',
  color: '#4b5563',
  flexShrink: 1,
  textAlign: 'center',
},
freemiumOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0,0,0,0.55)',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 18,
},

freemiumModal: {
  width: '92%',
  maxWidth: 460,
  backgroundColor: '#fff',
  borderRadius: 24,
  padding: 22,
  position: 'relative',
  alignItems: 'center',
  borderWidth: 1,
  borderColor: 'rgba(17,24,39,0.08)',
},

freemiumClose: {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 30,
  height: 30,
  borderRadius: 999,
  backgroundColor: '#f3f3f3',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20,
},

freemiumCloseLocked: {
  opacity: 0.35,
},

freemiumCloseText: {
  fontSize: 20,
  fontWeight: '900',
  color: '#111827',
},

freemiumTitle: {
  fontSize: 24,
  lineHeight: 29,
  fontWeight: '700',
  color: '#111827',
  textAlign: 'center',
  marginBottom: 15,
  marginTop: 18,
},

freemiumTitleBold: {
  fontWeight: '900',
},

freemiumTryBtn: {
  width: '100%',
  borderRadius: 999,
  paddingVertical: 14,
  paddingHorizontal: 12,
  backgroundColor: '#dcfce7',
  alignItems: 'center',
  justifyContent: 'center',
},

freemiumBtnInner: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
},

freemiumBtnTick: {
  width: 18,
  height: 18,
  borderRadius: 999,
  backgroundColor: '#22c55e',
  alignItems: 'center',
  justifyContent: 'center',
},

freemiumBtnTickText: {
  color: '#fff',
  fontSize: 11,
  fontWeight: '900',
},

freemiumBtnText: {
  color: '#166534',
  fontSize: 14,
  fontWeight: '900',
  textAlign: 'center',
},

freemiumProof: {
  marginTop: 26,
  backgroundColor: '#f8fafc',
  borderWidth: 1,
  borderColor: '#e5e7eb',
  opacity: 0.72,
  borderRadius: 14,
  paddingVertical: 9,
  paddingHorizontal: 12,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
},

verifyTick: {
  width: 18,
  height: 18,
  borderRadius: 999,
  backgroundColor: '#1d9bf0',
  alignItems: 'center',
  justifyContent: 'center',
},

verifyTickText: {
  color: '#fff',
  fontSize: 11,
  fontWeight: '900',
},

freemiumProofText: {
  fontSize: 12,
  fontWeight: '700',
  color: '#4b5563',
  flexShrink: 1,
  textAlign: 'center',
},
suggestedListingOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0,0,0,0.55)',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 18,
},

suggestedListingModal: {
  width: '100%',
  maxWidth: 430,
  backgroundColor: '#fff',
  borderRadius: 24,
  padding: 22,
  alignItems: 'center',
  position: 'relative',
},

suggestedListingClose: {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 32,
  height: 32,
  borderRadius: 16,
  backgroundColor: '#f3f3f3',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 5,
},

suggestedListingCloseLocked: {
  opacity: 0.35,
},

suggestedListingCloseText: {
  fontSize: 22,
  fontWeight: '900',
  color: '#111',
  lineHeight: 24,
},

suggestedListingIcon: {
  width: 56,
  height: 56,
  borderRadius: 28,
  backgroundColor: '#eef7ff',
  borderWidth: 1,
  borderColor: '#cfe7ff',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 14,
},

suggestedListingIconText: {
  fontSize: 24,
},

suggestedListingModalTitle: {
  fontSize: 23,
  fontWeight: '800',
  color: '#111827',
  textAlign: 'center',
  marginBottom: 10,
  lineHeight: 27,
},

suggestedListingModalSub: {
  fontSize: 13,
  color: '#4b5563',
  textAlign: 'center',
  lineHeight: 20,
  marginBottom: 16,
},

suggestedListingMiniOffer: {
  width: '100%',
  backgroundColor: '#f8fafc',
  borderWidth: 1,
  borderColor: '#e5e7eb',
  borderRadius: 16,
  padding: 14,
  marginBottom: 15,
},

suggestedListingMiniLabel: {
  fontSize: 11,
  fontWeight: '900',
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: 1,
  marginBottom: 5,
},

suggestedListingMiniText: {
  fontSize: 14,
  fontWeight: '800',
  color: '#111827',
  lineHeight: 20,
},

suggestedListingMiniValue: {
  marginTop: 5,
  fontSize: 12,
  color: '#4b5563',
  fontWeight: '700',
},

suggestedListingPrimaryBtn: {
  width: '100%',
  backgroundColor: '#FDF05D',
  borderRadius: 999,
  paddingVertical: 14,
  paddingHorizontal: 16,
  alignItems: 'center',
},

suggestedListingPrimaryText: {
  color: '#111827',
  fontSize: 14,
  fontWeight: '900',
},

suggestedListingGhostBtn: {
  marginTop: 9,
  width: '100%',
  backgroundColor: '#f3f3f3',
  borderRadius: 999,
  paddingVertical: 12,
  paddingHorizontal: 16,
  alignItems: 'center',
},

suggestedListingGhostText: {
  color: '#4b5563',
  fontSize: 13,
  fontWeight: '800',
},

suggestedListingInfoCard: {
  width: '90%',
  alignSelf: 'center',
  marginTop: 12,
  marginBottom: 12,
  backgroundColor: '#eef7ff',
  borderWidth: 1,
  borderColor: '#cfe7ff',
  borderRadius: 18,
  padding: 14,
  flexDirection: 'row',
  alignItems: 'center',
},

suggestedListingInfoIcon: {
  width: 34,
  height: 34,
  borderRadius: 17,
  backgroundColor: '#dff0ff',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 11,
},

suggestedListingInfoIconText: {
  color: '#1f5d8f',
  fontWeight: '900',
  fontSize: 15,
},

suggestedListingInfoTextWrap: {
  flex: 1,
},
positiveReviewsBar: {
  width: '90%',
  alignSelf: 'center',
  backgroundColor: '#f3f3f3',
  borderWidth: 1,
  borderColor: '#d6d6d6',
  borderRadius: 23,
  paddingVertical: 12,
  paddingHorizontal: 14,
  marginTop: 12,
  marginBottom: 10,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.06,
  shadowRadius: 5,
  elevation: 2,
},

positiveReviewsLeft: {
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
  paddingRight: 10,
},

positiveReviewsText: {
  fontSize: 14,
  fontWeight: '700',
  color: '#111',
},

positiveReviewsRight: {
  flexDirection: 'row',
  alignItems: 'center',
},

positiveReviewsNewBadge: {
  position: 'absolute',
  top: -8,
  right: 14,
  backgroundColor: '#FDF05D',
  borderRadius: 999,
  paddingVertical: 3,
  paddingHorizontal: 7,
  borderWidth: 1,
  borderColor: '#e0d64e',
  zIndex: 10,
},

positiveReviewsNewBadgeText: {
  fontSize: 9,
  fontWeight: '900',
  color: '#000',
  letterSpacing: 0.5,
},

suggestedListingInfoTitle: {
  fontSize: 14,
  fontWeight: '800',
  color: '#12334f',
  marginBottom: 3,
},

suggestedListingInfoSub: {
  fontSize: 12,
  color: '#29445c',
  lineHeight: 17,
},
customerChatFloatWrap: {
  position: Platform.OS === 'web' ? 'fixed' : 'absolute',
  left: 18,
  bottom: 78,
  zIndex: 999999,
  elevation: 999999,
},

customerChatFloat: {
  width: 52,
  height: 52,
  borderRadius: 999,
  borderWidth: 1,
borderColor: '#F3F3F3',
  backgroundColor: 'black',
  alignItems: 'center',
  justifyContent: 'center',
  shadowColor: '#0F172A',
  shadowOffset: { width: 0, height: 18 },
  shadowOpacity: 0.28,
  shadowRadius: 45,
},

customerChatFloatPulse: {
  position: 'absolute',
  top: 7,
  right: 7,
  width: 10,
  height: 10,
  borderRadius: 999,
  backgroundColor: '#4CD964',
  borderWidth: 2,
  borderColor: '#111827',
},
customerSupportOverlay: {
  flex: 1,
  backgroundColor: 'rgba(0,0,0,0.48)',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 18,
},

customerSupportModal: {
  width: '100%',
  maxWidth: 500,
  backgroundColor: '#ffffff',
  borderRadius: 24,
  padding: 22,
  position: 'relative',
  borderWidth: 1,
  borderColor: 'rgba(17,24,39,0.08)',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 22 },
  shadowOpacity: 0.24,
  shadowRadius: 60,
  elevation: 20,
},

mobileHeaderIdentity: {
  flex: 1,
  minWidth: 0,
},

mobileHeaderTitleRow: {
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  columnGap: 8,
  rowGap: 6,
},

mobileHeaderGreeting: {
  fontSize: 16,
  fontWeight: 'bold',
  color: 'black',
  flexShrink: 1,
},

mobileAccountPlanBadge: {
  minHeight: 36,
  paddingVertical: 5,
  paddingHorizontal: 10,
  borderRadius: 15,
  marginLeft: 10,
  borderWidth: 1.25,
  borderColor: '#AEB8A9',

  backgroundColor: '#f3f3f3',

  justifyContent: 'center',
  alignItems: 'flex-start',
  alignSelf: 'flex-start',
},

mobileAccountPlanLabel: {
  fontSize: 8,
  lineHeight: 10,
  fontWeight: '600',
  color: '#74776d',
  marginBottom: 1,
},

mobileAccountPlanName: {
  fontSize: 10,
  lineHeight: 13,
  fontWeight: '800',
  color: '#111827',
},
customerSupportClose: {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 32,
  height: 32,
  borderRadius: 999,
  backgroundColor: '#F3F4F6',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 5,
},

customerSupportCloseText: {
  color: '#111827',
  fontSize: 22,
  fontWeight: '900',
  lineHeight: 24,
},

customerSupportTop: {
  flexDirection: 'row',
  alignItems: 'flex-start',
  paddingRight: 28,
  marginBottom: 16,
},

customerSupportIcon: {
  width: 42,
  height: 42,
  borderRadius: 999,
  backgroundColor: '#111827',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
  shadowColor: '#111827',
  shadowOffset: { width: 0, height: 12 },
  shadowOpacity: 0.18,
  shadowRadius: 28,
  elevation: 5,
},

customerSupportTitle: {
  fontSize: 20,
  lineHeight: 24,
  fontWeight: '900',
  color: '#111827',
},

customerSupportSub: {
  marginTop: 7,
  fontSize: 13,
  lineHeight: 19,
  color: '#6B7280',
  fontWeight: '600',
},

customerSupportForm: {
  width: '100%',
},

customerSupportField: {
  marginBottom: 12,
},

customerSupportLabel: {
  fontSize: 12,
  fontWeight: '900',
  color: '#111827',
  marginBottom: 6,
},

customerSupportLabelRow: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 6,
},

customerSupportRecommended: {
  fontSize: 10,
  fontWeight: '900',
  color: '#166534',
  backgroundColor: '#DCFCE7',
  borderWidth: 1,
  borderColor: '#BBF7D0',
  borderRadius: 999,
  paddingVertical: 3,
  paddingHorizontal: 8,
  overflow: 'hidden',
},

customerSupportTextarea: {
  width: '100%',
  minHeight: 118,
  borderWidth: 1,
  borderColor: '#E5E7EB',
  backgroundColor: '#F9FAFB',
  color: '#111827',
  borderRadius: 16,
  paddingVertical: 12,
  paddingHorizontal: 13,
  fontSize: 14,
  lineHeight: 20,
},

customerSupportInput: {
  width: '100%',
  borderWidth: 1,
  borderColor: '#E5E7EB',
  backgroundColor: '#F9FAFB',
  color: '#111827',
  borderRadius: 16,
  paddingVertical: 12,
  paddingHorizontal: 13,
  fontSize: 14,
},

customerSupportError: {
  backgroundColor: '#FEF2F2',
  borderWidth: 1,
  borderColor: '#FECACA',
  borderRadius: 14,
  paddingVertical: 10,
  paddingHorizontal: 12,
  marginBottom: 12,
},

customerSupportErrorText: {
  color: '#991B1B',
  fontSize: 12,
  fontWeight: '800',
},

customerSupportSuccess: {
  backgroundColor: '#F0FDF4',
  borderWidth: 1,
  borderColor: '#BBF7D0',
  borderRadius: 16,
  paddingVertical: 13,
  paddingHorizontal: 14,
},

customerSupportSuccessText: {
  color: '#166534',
  fontSize: 13,
  lineHeight: 20,
  fontWeight: '800',
},

customerSupportRef: {
  marginTop: 10,
  alignSelf: 'flex-start',
  borderRadius: 999,
  backgroundColor: '#ffffff',
  borderWidth: 1,
  borderColor: '#BBF7D0',
  paddingVertical: 6,
  paddingHorizontal: 10,
},

customerSupportRefText: {
  color: '#166534',
  fontSize: 12,
  fontWeight: '900',
},

customerSupportFaqRow: {
  marginTop: 10,
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
},

customerSupportFaqText: {
  color: '#166534',
  fontSize: 13,
  lineHeight: 20,
  fontWeight: '800',
},

customerSupportFaqLink: {
  color: '#166534',
  fontSize: 13,
  lineHeight: 20,
  fontWeight: '900',
  textDecorationLine: 'underline',
},

customerSupportSubmit: {
  width: '100%',
  borderRadius: 999,
  paddingVertical: 13,
  paddingHorizontal: 14,
  backgroundColor: '#FDF05D',
  alignItems: 'center',
  justifyContent: 'center',
  shadowColor: '#111827',
  shadowOffset: { width: 0, height: 10 },
  shadowOpacity: 0.08,
  shadowRadius: 22,
  elevation: 3,
},

customerSupportSubmitDisabled: {
  opacity: 0.55,
},
/* === CLARA MOBILE === */

claraMobileBar: {
  width: '90%',
  alignSelf: 'center',

  marginTop: 8,
  marginBottom: 10,

  minHeight: 76,

  paddingVertical: 11,
  paddingHorizontal: 14,

  borderRadius: 26,

  backgroundColor: '#F8F8F6',

  flexDirection: 'row',
  alignItems: 'center',
},

claraMobileOrb: {
  width: 48,
  height: 48,

  borderRadius: 24,

  backgroundColor: '#111214',

  alignItems: 'center',
  justifyContent: 'center',

  marginRight: 13,

  position: 'relative',
},

claraMobileOrbInner: {
  width: 18,
  height: 18,

  borderRadius: 9,

  backgroundColor: '#FDF05D',
},

claraMobileOrbDot: {
  position: 'absolute',

  top: 8,
  right: 8,

  width: 5,
  height: 5,

  borderRadius: 3,

  backgroundColor: '#FDF05D',
},

claraMobileCopy: {
  flex: 1,
},

claraMobileTopLine: {
  flexDirection: 'row',
  alignItems: 'center',

  marginBottom: 2,
},

claraMobileKicker: {
  fontSize: 7,
  fontWeight: '700',

  letterSpacing: 1.1,

  color: '#8C9097',
},

claraMobileNew: {
  marginLeft: 7,

  paddingHorizontal: 6,
  paddingVertical: 2,

  borderRadius: 10,

  backgroundColor: '#FDF05D',

  color: '#111214',

  fontSize: 6,
  fontWeight: '900',

  overflow: 'hidden',
},

claraMobileTitle: {
  fontSize: 22,
  lineHeight: 25,

  fontWeight: '500',

  color: '#111827',

  letterSpacing: -0.6,
},

claraMobileTitleAccent: {
  fontSize: 22,
  fontWeight: '900',

  color: '#B5A600',

  letterSpacing: -0.7,
},

claraMobileSub: {
  marginTop: 1,

  fontSize: 9,
  fontWeight: '500',

  color: '#858A93',
},

claraMobileArrow: {
  marginLeft: 10,

  fontSize: 21,
  fontWeight: '400',

  color: '#111214',
},

customerSupportSubmitText: {
  color: '#111827',
  fontSize: 14,
  fontWeight: '900',
},
});

export default App;
